// import React, { useState, useEffect } from 'react';
// import { database, ref, onValue, push, auth, createUserWithEmailAndPassword } from '../firebase';

// const ManageEmployeeRole = () => {
//   const [active, setActive] = useState(true);
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [address, setAddress] = useState('');
//   const [phone, setPhone] = useState('');
//   const [bloodGroup, setBloodGroup] = useState('');
//   const [dob, setDob] = useState('');
//   const [userRole, setUserRole] = useState('');
//   const [loginType, setLoginType] = useState('Main Login');
//   const [assignLocation, setAssignLocation] = useState('');
//   const [flatDiscount, setFlatDiscount] = useState(false);
//   const [dayEndDenomination, setDayEndDenomination] = useState(false);
//   const [loginId, setLoginId] = useState('');
//   const [password, setPassword] = useState('');
//   const [retypePassword, setRetypePassword] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [showEmployeeForm, setShowEmployeeForm] = useState(false);

//   useEffect(() => {
//     const employeesRef = ref(database, 'employees');
//     onValue(employeesRef, (snapshot) => {
//       const data = snapshot.val();
//       const employeesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
//       setEmployees(employeesList);
//     });
//   }, []);

//   const handleAddEmployee = async (e) => {
//     e.preventDefault();
//     if (password !== retypePassword) {
//       alert("Passwords don't match!");
//       return;
//     }

//     if (name && email && address && phone && userRole && loginId && password) {
//       try {
//         await createUserWithEmailAndPassword(auth, email, password);
//         const employeesRef = ref(database, 'employees');
//         await push(employeesRef, {
//           active,
//           name,
//           email,
//           address,
//           phone,
//           bloodGroup,
//           dob,
//           userRole,
//           loginType,
//           assignLocation,
//           flatDiscount,
//           dayEndDenomination,
//           loginId
//         });
//         handleResetForm();
//         setShowEmployeeForm(false);
//       } catch (error) {
//         console.error("Error adding employee: ", error);
//         alert(`Failed to add employee: ${error.message}`);
//       }
//     } else {
//       alert("Please fill in all required fields!");
//     }
//   };

//   const handleResetForm = () => {
//     setActive(true);
//     setName('');
//     setEmail('');
//     setAddress('');
//     setPhone('');
//     setBloodGroup('');
//     setDob('');
//     setUserRole('');
//     setLoginType('Main Login');
//     setAssignLocation('');
//     setFlatDiscount(false);
//     setDayEndDenomination(false);
//     setLoginId('');
//     setPassword('');
//     setRetypePassword('');
//   };

//   const styles = {
//     container: {
//       maxWidth: '100%',
//       margin: '0 auto',
//       padding: '1rem',
//       backgroundColor: '#f8fafc',
//       minHeight: '100vh',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '12px',
//       padding: '1.5rem',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       margin: '0 auto',
//       maxWidth: '1200px',
//       overflowX: 'auto',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '1.5rem',
//       flexWrap: 'wrap',
//       gap: '1rem',
//     },
//     headerTitle: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       color: '#2563eb',
//     },
//     headerButtons: {
//       display: 'flex',
//       gap: '0.5rem',
//       flexWrap: 'wrap',
//       alignItems: 'center',
//     },
//     addButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//     },
//     section: {
//       backgroundColor: '#fff',
//       padding: '1.25rem',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
//       overflowY: 'auto',
//     },
//     sectionHeading: {
//       fontSize: '1.1rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     gridContainer: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//       gap: '1rem',
//     },
//     formGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       marginBottom: '0.75rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.8rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.8rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.8rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     radioGroup: {
//       display: 'flex',
//       gap: '1rem',
//       marginBottom: '1rem',
//       alignItems: 'center',
//     },
//     radioLabel: {
//       display: 'flex',
//       alignItems: 'center',
//       fontSize: '0.8rem',
//       color: '#374151',
//       fontWeight: '500',
//     },
//     radioInput: {
//       marginRight: '0.5rem',
//       cursor: 'pointer',
//     },
//     checkboxGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       marginBottom: '0.75rem',
//     },
//     tableContainer: {
//       marginTop: '1rem',
//       overflowX: 'auto',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       position: 'relative',
//       maxWidth: '100%',
//       background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(241,245,249,0.95) 100%)',
//       boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.75rem',
//       minWidth: '1000px',
//     },
//     tableHeader: {
//       padding: '0.5rem',
//       textAlign: 'center',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.7rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//       whiteSpace: 'nowrap',
//     },
//     tableCell: {
//       padding: '0.5rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//       textAlign: 'center',
//     },
//     modal: {
//       position: 'fixed',
//       top: '50%',
//       left: '50%',
//       transform: 'translate(-50%, -50%)',
//       backgroundColor: 'white',
//       padding: '1.5rem',
//       borderRadius: '8px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       zIndex: 1000,
//       width: '90%',
//       maxWidth: '800px',
//       maxHeight: '90vh',
//       overflowY: 'auto',
//     },
//     modalHeader: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '0.75rem 1.25rem',
//       borderTopLeftRadius: '8px',
//       borderTopRightRadius: '8px',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       margin: '-1.5rem -1.5rem 1rem -1.5rem',
//     },
//     modalTitle: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//     },
//     modalCloseButton: {
//       background: 'none',
//       border: 'none',
//       color: 'white',
//       fontSize: '1.5rem',
//       cursor: 'pointer',
//     },
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       zIndex: 999,
//     },
//     actionButtons: {
//       marginTop: '1.5rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '0.75rem',
//       paddingTop: '0.75rem',
//       borderTop: '1px solid #e2e8f0',
//       flexWrap: 'wrap',
//     },
//     actionButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.8rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//       transform: 'translateY(0)',
//     },
//     addButtonModal: {
//       backgroundColor: '#10b981',
//       color: 'white',
//       boxShadow: '0 1px 4px rgba(16, 185, 129, 0.3)',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//       boxShadow: '0 1px 4px rgba(220, 38, 38, 0.3)',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.formWrapper}>
//         <div style={styles.header}>
//           <div style={styles.headerTitle}>Manage Employee Role</div>
//           <div style={styles.headerButtons}>
//             <button
//               style={styles.addButton}
//               onClick={() => setShowEmployeeForm(true)}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               + Add Employee
//             </button>
//           </div>
//         </div>
//         <div style={styles.section}>
//           <h2 style={styles.sectionHeading}>📋 Employee List</h2>
//           <div style={styles.tableContainer}>
//             <table style={styles.table}>
//               <thead>
//                 <tr>
//                   <th style={styles.tableHeader}>ID</th>
//                   <th style={styles.tableHeader}>USER NAME</th>
//                   <th style={styles.tableHeader}>ROLE</th>
//                   <th style={styles.tableHeader}>LOGIN ID</th>
//                   <th style={styles.tableHeader}>EMAIL</th>
//                   <th style={styles.tableHeader}>BRANCH</th>
//                   <th style={styles.tableHeader}>ASSIGNED LOCATION</th>
//                   <th style={styles.tableHeader}>STATUS</th>
//                   <th style={styles.tableHeader}>ACTION</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {employees.map((employee, index) => (
//                   <tr
//                     key={employee.id}
//                     style={{
//                       backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                       transition: 'background-color 0.2s ease',
//                     }}
//                   >
//                     <td style={styles.tableCell}>{index + 1}</td>
//                     <td style={styles.tableCell}>{employee.name}</td>
//                     <td style={styles.tableCell}>{employee.userRole}</td>
//                     <td style={styles.tableCell}>{employee.loginId}</td>
//                     <td style={styles.tableCell}>{employee.email}</td>
//                     <td style={styles.tableCell}>SUPREME TRADE</td>
//                     <td style={styles.tableCell}>{employee.assignLocation}</td>
//                     <td style={styles.tableCell}>{employee.active ? 'Active' : 'Inactive'}</td>
//                     <td style={styles.tableCell}>
//                       <span style={{ color: '#f44336', cursor: 'pointer' }}>✏️</span>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>
//       </div>
//       {showEmployeeForm && (
//         <>
//           <div style={styles.overlay} onClick={() => setShowEmployeeForm(false)} />
//           <div style={styles.modal}>
//             <div style={styles.modalHeader}>
//               <h2 style={styles.modalTitle}>Add New Employee</h2>
//               <button
//                 style={styles.modalCloseButton}
//                 onClick={() => setShowEmployeeForm(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>📋 Personal Details</h3>
//                 <div style={styles.radioGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="radio"
//                       checked={active}
//                       onChange={() => setActive(true)}
//                       style={styles.radioInput}
//                     />
//                     Active
//                   </label>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="radio"
//                       checked={!active}
//                       onChange={() => setActive(false)}
//                       style={styles.radioInput}
//                     />
//                     Inactive
//                   </label>
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Name *</label>
//                   <input
//                     type="text"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     style={styles.input}
//                     placeholder="Name"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Email *</label>
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     style={styles.input}
//                     placeholder="Email"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Address *</label>
//                   <input
//                     type="text"
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)}
//                     style={styles.input}
//                     placeholder="Address"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Phone No. *</label>
//                   <input
//                     type="text"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)}
//                     style={styles.input}
//                     placeholder="Phone No."
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Blood Group</label>
//                   <input
//                     type="text"
//                     value={bloodGroup}
//                     onChange={(e) => setBloodGroup(e.target.value)}
//                     style={styles.input}
//                     placeholder="Blood Group"
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Date of Birth</label>
//                   <input
//                     type="date"
//                     value={dob}
//                     onChange={(e) => setDob(e.target.value)}
//                     style={styles.input}
//                     placeholder="D.O.B"
//                   />
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>🔑 Login Details</h3>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>User Role *</label>
//                   <select
//                     value={userRole}
//                     onChange={(e) => setUserRole(e.target.value)}
//                     style={styles.select}
//                     required
//                   >
//                     <option value="">--Select--</option>
//                     <option value="SAN ADMIN">SAN ADMIN</option>
//                     <option value="ADMIN">ADMIN</option>
//                     <option value="WAREHOUSE MANAGER">WAREHOUSE MANAGER</option>
//                     <option value="STORE MANAGER">STORE MANAGER</option>
//                     <option value="BILLER">BILLER</option>
//                   </select>
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Login Type</label>
//                   <select
//                     value={loginType}
//                     onChange={(e) => setLoginType(e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="Main Login">Main Login</option>
//                     <option value="Sub Login">Sub Login</option>
//                   </select>
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Assign Location</label>
//                   <select
//                     value={assignLocation}
//                     onChange={(e) => setAssignLocation(e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">Select</option>
//                     <option value="WAREHOUSE/Warehouse/Puduche">WAREHOUSE/Warehouse/Puduche</option>
//                     <option value="STORE/Store/CITY">STORE/Store/CITY</option>
//                   </select>
//                 </div>
//                 <div style={styles.checkboxGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="checkbox"
//                       checked={flatDiscount}
//                       onChange={(e) => setFlatDiscount(e.target.checked)}
//                       style={styles.radioInput}
//                     />
//                     Flat Discount
//                   </label>
//                 </div>
//                 <div style={styles.checkboxGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="checkbox"
//                       checked={dayEndDenomination}
//                       onChange={(e) => setDayEndDenomination(e.target.checked)}
//                       style={styles.radioInput}
//                     />
//                     Day End Denomination
//                   </label>
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>🔒 Credentials</h3>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Login ID *</label>
//                   <input
//                     type="text"
//                     value={loginId}
//                     onChange={(e) => setLoginId(e.target.value)}
//                     style={styles.input}
//                     placeholder="Login ID"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Password *</label>
//                   <input
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     style={styles.input}
//                     placeholder="Password"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Retype Password *</label>
//                   <input
//                     type="password"
//                     value={retypePassword}
//                     onChange={(e) => setRetypePassword(e.target.value)}
//                     style={styles.input}
//                     placeholder="Retype Password"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div style={styles.actionButtons}>
//               <button
//                 style={{ ...styles.actionButton, ...styles.addButtonModal }}
//                 onClick={handleAddEmployee}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                 }}
//               >
//                 ADD
//               </button>
//               <button
//                 style={{ ...styles.actionButton, ...styles.cancelButton }}
//                 onClick={() => {
//                   handleResetForm();
//                   setShowEmployeeForm(false);
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                 }}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </>
//       )}
//     </div>
//   );
// };

// export default ManageEmployeeRole;

// import React, { useState, useEffect } from 'react';
// import { database, ref, onValue, push, auth, createUserWithEmailAndPassword } from '../firebase';

// const ManageEmployeeRole = () => {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [active, setActive] = useState(true);
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [address, setAddress] = useState('');
//   const [phone, setPhone] = useState('');
//   const [bloodGroup, setBloodGroup] = useState('');
//   const [dob, setDob] = useState('');
//   const [userRole, setUserRole] = useState('');
//   const [loginType, setLoginType] = useState('Main Login');
//   const [branchId, setBranchId] = useState('');
//   const [flatDiscount, setFlatDiscount] = useState(false);
//   const [dayEndDenomination, setDayEndDenomination] = useState(false);
//   const [loginId, setLoginId] = useState('');
//   const [password, setPassword] = useState('');
//   const [retypePassword, setRetypePassword] = useState('');
//   const [assignLocation, setAssignLocation] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [showEmployeeForm, setShowEmployeeForm] = useState(false);
//   const [showBranchForm, setShowBranchForm] = useState(false);
//   const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);

//   // Branch form states
//   const [branchName, setBranchName] = useState('');
//   const [branchAddress, setBranchAddress] = useState('');
//   const [branchPhone, setBranchPhone] = useState('');
//   const [branchEmail, setBranchEmail] = useState('');
//   const [branchManager, setBranchManager] = useState('');

//   const encodeEmailForPath = (email) => {
//     return email.replace(/[.#$[\]]/g, '_');
//   };

//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged(user => {
//       setCurrentUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   useEffect(() => {
//     if (currentUser) {
//       const encodedEmail = encodeEmailForPath(currentUser.email);
//       // Employees under logged-in admin
//       const employeesRef = ref(database, `users/${encodedEmail}/employees`);
//       const unsubscribeEmployees = onValue(employeesRef, snapshot => {
//         const data = snapshot.val();
//         setEmployees(data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : []);
//       });
//       // Branches under logged-in admin (from branchProfiles)
//       const branchProfilesRef = ref(database, `users/${encodedEmail}/branchProfiles`);
//       const unsubscribeBranches = onValue(branchProfilesRef, snapshot => {
//         const data = snapshot.val();
//         setBranches(data ? Object.entries(data).map(([id, profile]) => ({
//           id,
//           name: profile.branchName,
//           address: profile.address1,
//           phone: profile.phoneNo,
//           email: profile.email,
//           manager: profile.manager || ''
//         })) : []);
//       });
//       return () => {
//         unsubscribeEmployees();
//         unsubscribeBranches();
//       };
//     }
//   }, [currentUser]);

//   const handleAddEmployee = async e => {
//     e.preventDefault();
//     if (password !== retypePassword) {
//       alert("Passwords don't match!"); return;
//     }
//     if (
//       name && email && address && phone && userRole && loginId &&
//       password && currentUser && branchId
//     ) {
//       try {
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         const encodedEmail = encodeEmailForPath(currentUser.email);
//         await push(ref(database, `users/${encodedEmail}/employees`), {
//           active,
//           name,
//           email,
//           address,
//           phone,
//           bloodGroup,
//           dob,
//           userRole,
//           loginType,
//           branchId,
//           assignLocation,
//           flatDiscount,
//           dayEndDenomination,
//           loginId,
//           createdAt: new Date().toISOString(),
//           createdBy: currentUser.uid,
//           superAdminEmail: currentUser.email,
//           superAdminId: currentUser.uid,
//           firebaseUid: userCredential.user.uid
//         });
//         await push(ref(database, `users/${userCredential.user.uid}/profile`), {
//           role: 'employee',
//           superAdminId: currentUser.uid,
//           superAdminEmail: currentUser.email,
//           branchId,
//           assignLocation,
//           canAccessSuperAdminData: true,
//           personalInfo: {
//             name, email, address, phone, bloodGroup, dob, userRole, loginId, assignLocation
//           }
//         });
//         handleResetForm();
//         setShowEmployeeForm(false);
//         alert('Employee added successfully!');
//       } catch (err) {
//         console.error("Error adding employee:", err);
//         alert(`Failed to add employee: ${err.message}`);
//       }
//     } else {
//       alert("Please fill in all required fields (including branch)!");
//     }
//   };

//   const handleAddBranch = async e => {
//     e.preventDefault();
//     if (branchName && branchAddress && currentUser) {
//       try {
//         const encodedEmail = encodeEmailForPath(currentUser.email);
//         const branchesRef = ref(database, `users/${encodedEmail}/branchProfiles`);
//         const newBranch = await push(branchesRef, {
//           branchName,
//           address1: branchAddress,
//           phoneNo: branchPhone,
//           email: branchEmail,
//           manager: branchManager,
//           createdAt: new Date().toISOString(),
//           updatedAt: new Date().toISOString(),
//           userEmail: currentUser.email
//         });
//         setBranchName('');
//         setBranchAddress('');
//         setBranchPhone('');
//         setBranchEmail('');
//         setBranchManager('');
//         setShowBranchForm(false);
//         alert(`Branch added successfully! Branch ID: ${newBranch.key}`);
//       } catch (err) {
//         console.error("Error adding branch:", err);
//         alert(`Failed to add branch: ${err.message}`);
//       }
//     } else {
//       alert("Please fill in required branch fields!");
//     }
//   };

//   const handleResetForm = () => {
//     setActive(true);
//     setName('');
//     setEmail('');
//     setAddress('');
//     setPhone('');
//     setBloodGroup('');
//     setDob('');
//     setUserRole('');
//     setLoginType('Main Login');
//     setBranchId('');
//     setAssignLocation('');
//     setFlatDiscount(false);
//     setDayEndDenomination(false);
//     setLoginId('');
//     setPassword('');
//     setRetypePassword('');
//   };

//   const handleEmployeeClick = employee => {
//     setSelectedEmployee(employee);
//     setShowEmployeeDetails(true);
//   };

//   // Helper to display branch name from ID
//   const resolveBranchName = id => branches.find(b => b.id === id)?.name || 'Unknown';

//   // UI Rendering
//   if (!currentUser) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '100vh',
//         fontSize: '1.2rem',
//         color: '#6b7280'
//       }}>
//         Please log in to access employee management.
//       </div>
//     );
//   }

//   const styles = {
//     container: {
//       maxWidth: '100%',
//       margin: '0 auto',
//       padding: '1rem',
//       backgroundColor: '#f8fafc',
//       minHeight: '100vh',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '12px',
//       padding: '1.5rem',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       margin: '0 auto',
//       maxWidth: '1200px',
//       overflowX: 'auto',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '1.5rem',
//       flexWrap: 'wrap',
//       gap: '1rem',
//     },
//     headerTitle: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       color: '#2563eb',
//     },
//     headerButtons: {
//       display: 'flex',
//       gap: '0.5rem',
//       flexWrap: 'wrap',
//       alignItems: 'center',
//     },
//     addButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
//       transform: 'translateY(0)',
//     },
//     branchButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: 'pointer',
//       border: 'none',
//       fontSize: '0.8rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//       transform: 'translateY(0)',
//     },
//     section: {
//       backgroundColor: '#fff',
//       padding: '1.25rem',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
//       overflowY: 'auto',
//       marginBottom: '1rem',
//     },
//     sectionHeading: {
//       fontSize: '1.1rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     gridContainer: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//       gap: '1rem',
//     },
//     formGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       marginBottom: '0.75rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.8rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.8rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.8rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     radioGroup: {
//       display: 'flex',
//       gap: '1rem',
//       marginBottom: '1rem',
//       alignItems: 'center',
//     },
//     radioLabel: {
//       display: 'flex',
//       alignItems: 'center',
//       fontSize: '0.8rem',
//       color: '#374151',
//       fontWeight: '500',
//     },
//     radioInput: {
//       marginRight: '0.5rem',
//       cursor: 'pointer',
//     },
//     checkboxGroup: {
//       display: 'flex',
//       flexDirection: 'column',
//       marginBottom: '0.75rem',
//     },
//     tableContainer: {
//       marginTop: '1rem',
//       overflowX: 'auto',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       position: 'relative',
//       maxWidth: '100%',
//       background: 'linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(241,245,249,0.95) 100%)',
//       boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.05)',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.75rem',
//       minWidth: '1000px',
//     },
//     tableHeader: {
//       padding: '0.5rem',
//       textAlign: 'center',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.7rem',
//       textTransform: 'uppercase',
//       letterSpacing: '0.5px',
//       border: '1px solid #1e40af',
//       whiteSpace: 'nowrap',
//     },
//     tableCell: {
//       padding: '0.5rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       verticalAlign: 'middle',
//       textAlign: 'center',
//       cursor: 'pointer',
//     },
//     modal: {
//       position: 'fixed',
//       top: '50%',
//       left: '50%',
//       transform: 'translate(-50%, -50%)',
//       backgroundColor: 'white',
//       padding: '1.5rem',
//       borderRadius: '8px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       zIndex: 1000,
//       width: '90%',
//       maxWidth: '800px',
//       maxHeight: '90vh',
//       overflowY: 'auto',
//     },
//     fullPageModal: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'white',
//       zIndex: 1000,
//       overflowY: 'auto',
//       padding: '2rem',
//     },
//     modalHeader: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '0.75rem 1.25rem',
//       borderTopLeftRadius: '8px',
//       borderTopRightRadius: '8px',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       margin: '-1.5rem -1.5rem 1rem -1.5rem',
//     },
//     fullPageHeader: {
//       backgroundColor: '#2563eb',
//       color: 'white',
//       padding: '1rem 2rem',
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       margin: '-2rem -2rem 2rem -2rem',
//       borderRadius: '0',
//     },
//     modalTitle: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//     },
//     modalCloseButton: {
//       background: 'none',
//       border: 'none',
//       color: 'white',
//       fontSize: '1.5rem',
//       cursor: 'pointer',
//     },
//     overlay: {
//       position: 'fixed',
//       top: 0,
//       left: 0,
//       right: 0,
//       bottom: 0,
//       backgroundColor: 'rgba(0,0,0,0.5)',
//       zIndex: 999,
//     },
//     actionButtons: {
//       marginTop: '1.5rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '0.75rem',
//       paddingTop: '0.75rem',
//       borderTop: '1px solid #e2e8f0',
//       flexWrap: 'wrap',
//     },
//     actionButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.8rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//       transform: 'translateY(0)',
//     },
//     addButtonModal: {
//       backgroundColor: '#10b981',
//       color: 'white',
//       boxShadow: '0 1px 4px rgba(16, 185, 129, 0.3)',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//       boxShadow: '0 1px 4px rgba(220, 38, 38, 0.3)',
//     },
//     branchCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '0.5rem 0',
//     },
//     branchName: {
//       fontSize: '1rem',
//       fontWeight: '600',
//       color: '#1f2937',
//       marginBottom: '0.5rem',
//     },
//     branchInfo: {
//       fontSize: '0.8rem',
//       color: '#6b7280',
//       marginBottom: '0.25rem',
//     },
//     employeeDetailCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1.5rem',
//       margin: '1rem 0',
//     },
//     detailRow: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       padding: '0.5rem 0',
//       borderBottom: '1px solid #e2e8f0',
//     },
//     detailLabel: {
//       fontWeight: '600',
//       color: '#374151',
//     },
//     detailValue: {
//       color: '#6b7280',
//     },
//   };

//   return (
//     <div style={styles.container}>
//       <div style={styles.formWrapper}>
//         <div style={styles.header}>
//           <div style={styles.headerTitle}>
//             Manage Employee Role & Branches
//             <div style={{ fontSize: '0.8rem', color: '#6b7280', fontWeight: '400' }}>
//               Logged in as: {currentUser.email}
//             </div>
//           </div>
//           <div style={styles.headerButtons}>
//             <button
//               style={styles.addButton}
//               onClick={() => setShowEmployeeForm(true)}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               + Add Employee
//             </button>
//             <button
//               style={styles.branchButton}
//               onClick={() => setShowBranchForm(true)}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//               }}
//             >
//               + Add Branch
//             </button>
//           </div>
//         </div>

//         {/* Branches Section */}
//         <div style={styles.section}>
//           <h2 style={styles.sectionHeading}>🏢 Branches ({branches.length})</h2>
//           {branches.length === 0 ? (
//             <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//               No branches added yet. Click "Add Branch" to create your first branch.
//             </p>
//           ) : (
//             <div style={styles.gridContainer}>
//               {branches.map((branch) => (
//                 <div key={branch.id} style={styles.branchCard}>
//                   <div style={styles.branchName}>{branch.name}</div>
//                   <div style={styles.branchInfo}>📍 {branch.address}</div>
//                   {branch.phone && <div style={styles.branchInfo}>📞 {branch.phone}</div>}
//                   {branch.email && <div style={styles.branchInfo}>📧 {branch.email}</div>}
//                   {branch.manager && <div style={styles.branchInfo}>👤 Manager: {branch.manager}</div>}
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>

//         {/* Employees Section */}
//         <div style={styles.section}>
//           <h2 style={styles.sectionHeading}>📋 Employee List ({employees.length})</h2>
//           {employees.length === 0 ? (
//             <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//               No employees added yet. Click "Add Employee" to add your first employee.
//             </p>
//           ) : (
//             <div style={styles.tableContainer}>
//               <table style={styles.table}>
//                 <thead>
//                   <tr>
//                     <th style={styles.tableHeader}>ID</th>
//                     <th style={styles.tableHeader}>USER NAME</th>
//                     <th style={styles.tableHeader}>ROLE</th>
//                     <th style={styles.tableHeader}>LOGIN ID</th>
//                     <th style={styles.tableHeader}>EMAIL</th>
//                     <th style={styles.tableHeader}>BRANCH</th>
//                     <th style={styles.tableHeader}>ASSIGNED LOCATION</th>
//                     <th style={styles.tableHeader}>STATUS</th>
//                     <th style={styles.tableHeader}>ACTION</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {employees.map((employee, index) => (
//                     <tr
//                       key={employee.id}
//                       style={{
//                         backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white',
//                         transition: 'background-color 0.2s ease',
//                       }}
//                       onClick={() => handleEmployeeClick(employee)}
//                     >
//                       <td style={styles.tableCell}>{index + 1}</td>
//                       <td style={styles.tableCell}>{employee.name}</td>
//                       <td style={styles.tableCell}>{employee.userRole}</td>
//                       <td style={styles.tableCell}>{employee.loginId}</td>
//                       <td style={styles.tableCell}>{employee.email}</td>
//                       <td style={styles.tableCell}>{resolveBranchName(employee.branchId)}</td>
//                       <td style={styles.tableCell}>{employee.assignLocation || 'Not assigned'}</td>
//                       <td style={styles.tableCell}>
//                         <span style={{ 
//                           color: employee.active ? '#10b981' : '#ef4444',
//                           fontWeight: '600'
//                         }}>
//                           {employee.active ? 'Active' : 'Inactive'}
//                         </span>
//                       </td>
//                       <td style={styles.tableCell}>
//                         <span style={{ color: '#f44336', cursor: 'pointer' }}>✏️</span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Employee Form Modal */}
//       {showEmployeeForm && (
//         <>
//           <div style={styles.overlay} onClick={() => setShowEmployeeForm(false)} />
//           <div style={styles.modal}>
//             <div style={styles.modalHeader}>
//               <h2 style={styles.modalTitle}>Add New Employee</h2>
//               <button
//                 style={styles.modalCloseButton}
//                 onClick={() => setShowEmployeeForm(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '1rem' }}>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>📋 Personal Details</h3>
//                 <div style={styles.radioGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="radio"
//                       checked={active}
//                       onChange={() => setActive(true)}
//                       style={styles.radioInput}
//                     />
//                     Active
//                   </label>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="radio"
//                       checked={!active}
//                       onChange={() => setActive(false)}
//                       style={styles.radioInput}
//                     />
//                     Inactive
//                   </label>
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Name *</label>
//                   <input
//                     type="text"
//                     value={name}
//                     onChange={(e) => setName(e.target.value)}
//                     style={styles.input}
//                     placeholder="Name"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Email *</label>
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     style={styles.input}
//                     placeholder="Email"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Address *</label>
//                   <input
//                     type="text"
//                     value={address}
//                     onChange={(e) => setAddress(e.target.value)}
//                     style={styles.input}
//                     placeholder="Address"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Phone No. *</label>
//                   <input
//                     type="text"
//                     value={phone}
//                     onChange={(e) => setPhone(e.target.value)}
//                     style={styles.input}
//                     placeholder="Phone No."
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Blood Group</label>
//                   <input
//                     type="text"
//                     value={bloodGroup}
//                     onChange={(e) => setBloodGroup(e.target.value)}
//                     style={styles.input}
//                     placeholder="Blood Group"
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Date of Birth</label>
//                   <input
//                     type="date"
//                     value={dob}
//                     onChange={(e) => setDob(e.target.value)}
//                     style={styles.input}
//                     placeholder="D.O.B"
//                   />
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>🔑 Login Details</h3>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>User Role *</label>
//                   <select
//                     value={userRole}
//                     onChange={(e) => setUserRole(e.target.value)}
//                     style={styles.select}
//                     required
//                   >
//                     <option value="">--Select--</option>
//                     <option value="SAN ADMIN">SAN ADMIN</option>
//                     <option value="ADMIN">ADMIN</option>
//                     <option value="WAREHOUSE MANAGER">WAREHOUSE MANAGER</option>
//                     <option value="STORE MANAGER">STORE MANAGER</option>
//                     <option value="BILLER">BILLER</option>
//                   </select>
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Login Type</label>
//                   <select
//                     value={loginType}
//                     onChange={(e) => setLoginType(e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="Main Login">Main Login</option>
//                     <option value="Sub Login">Sub Login</option>
//                   </select>
//                 </div>
            
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Assign Location</label>
//                   <select
//                     value={assignLocation}
//                     onChange={(e) => setAssignLocation(e.target.value)}
//                     style={styles.select}
//                   >
//                     <option value="">Select</option>
//                     {branches.map((branch) => (
//                       <option key={branch.id} value={branch.name}>
//                         {branch.name}
//                       </option>
//                     ))}
//                     <option value="WAREHOUSE/Warehouse/Puduche">WAREHOUSE/Warehouse/Puduche</option>
//                     <option value="STORE/Store/CITY">STORE/Store/CITY</option>
//                   </select>
//                 </div>
//                 <div style={styles.checkboxGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="checkbox"
//                       checked={flatDiscount}
//                       onChange={(e) => setFlatDiscount(e.target.checked)}
//                       style={styles.radioInput}
//                     />
//                     Flat Discount
//                   </label>
//                 </div>
//                 <div style={styles.checkboxGroup}>
//                   <label style={styles.radioLabel}>
//                     <input
//                       type="checkbox"
//                       checked={dayEndDenomination}
//                       onChange={(e) => setDayEndDenomination(e.target.checked)}
//                       style={styles.radioInput}
//                     />
//                     Day End Denomination
//                   </label>
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h3 style={styles.sectionHeading}>🔒 Credentials</h3>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Login ID *</label>
//                   <input
//                     type="text"
//                     value={loginId}
//                     onChange={(e) => setLoginId(e.target.value)}
//                     style={styles.input}
//                     placeholder="Login ID"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Password *</label>
//                   <input
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     style={styles.input}
//                     placeholder="Password"
//                     required
//                   />
//                 </div>
//                 <div style={styles.formGroup}>
//                   <label style={styles.label}>Retype Password *</label>
//                   <input
//                     type="password"
//                     value={retypePassword}
//                     onChange={(e) => setRetypePassword(e.target.value)}
//                     style={styles.input}
//                     placeholder="Retype Password"
//                     required
//                   />
//                 </div>
//               </div>
//             </div>
//             <div style={styles.actionButtons}>
//               <button
//                 style={{ ...styles.actionButton, ...styles.addButtonModal }}
//                 onClick={handleAddEmployee}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                 }}
//               >
//                 ADD
//               </button>
//               <button
//                 style={{ ...styles.actionButton, ...styles.cancelButton }}
//                 onClick={() => {
//                   handleResetForm();
//                   setShowEmployeeForm(false);
//                 }}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                 }}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Branch Form Modal */}
//       {showBranchForm && (
//         <>
//           <div style={styles.overlay} onClick={() => setShowBranchForm(false)} />
//           <div style={styles.modal}>
//             <div style={styles.modalHeader}>
//               <h2 style={styles.modalTitle}>Add New Branch</h2>
//               <button
//                 style={styles.modalCloseButton}
//                 onClick={() => setShowBranchForm(false)}
//               >
//                 ×
//               </button>
//             </div>
//             <div style={styles.section}>
//               <h3 style={styles.sectionHeading}>🏢 Branch Details</h3>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Branch Name *</label>
//                 <input
//                   type="text"
//                   value={branchName}
//                   onChange={(e) => setBranchName(e.target.value)}
//                   style={styles.input}
//                   placeholder="Branch Name"
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Address *</label>
//                 <input
//                   type="text"
//                   value={branchAddress}
//                   onChange={(e) => setBranchAddress(e.target.value)}
//                   style={styles.input}
//                   placeholder="Branch Address"
//                   required
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Phone</label>
//                 <input
//                   type="text"
//                   value={branchPhone}
//                   onChange={(e) => setBranchPhone(e.target.value)}
//                   style={styles.input}
//                   placeholder="Branch Phone"
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Email</label>
//                 <input
//                   type="email"
//                   value={branchEmail}
//                   onChange={(e) => setBranchEmail(e.target.value)}
//                   style={styles.input}
//                   placeholder="Branch Email"
//                 />
//               </div>
//               <div style={styles.formGroup}>
//                 <label style={styles.label}>Manager</label>
//                 <input
//                   type="text"
//                   value={branchManager}
//                   onChange={(e) => setBranchManager(e.target.value)}
//                   style={styles.input}
//                   placeholder="Branch Manager"
//                 />
//               </div>
//             </div>
//             <div style={styles.actionButtons}>
//               <button
//                 style={{ ...styles.actionButton, ...styles.addButtonModal }}
//                 onClick={handleAddBranch}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(16, 185, 129, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(16, 185, 129, 0.3)';
//                 }}
//               >
//                 ADD BRANCH
//               </button>
//               <button
//                 style={{ ...styles.actionButton, ...styles.cancelButton }}
//                 onClick={() => setShowBranchForm(false)}
//                 onMouseEnter={(e) => {
//                   e.target.style.transform = 'translateY(-1px)';
//                   e.target.style.boxShadow = '0 4px 12px rgba(220, 38, 38, 0.4)';
//                 }}
//                 onMouseLeave={(e) => {
//                   e.target.style.transform = 'translateY(0)';
//                   e.target.style.boxShadow = '0 2px 8px rgba(220, 38, 38, 0.3)';
//                 }}
//               >
//                 CANCEL
//               </button>
//             </div>
//           </div>
//         </>
//       )}

//       {/* Employee Details Full Page Modal */}
//       {showEmployeeDetails && selectedEmployee && (
//         <div style={styles.fullPageModal}>
//           <div style={styles.fullPageHeader}>
//             <h2 style={styles.modalTitle}>Employee Details - {selectedEmployee.name}</h2>
//             <button
//               style={styles.modalCloseButton}
//               onClick={() => setShowEmployeeDetails(false)}
//             >
//               ×
//             </button>
//           </div>
          
//           <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '2rem' }}>
//             <div style={styles.employeeDetailCard}>
//               <h3 style={styles.sectionHeading}>👤 Personal Information</h3>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Name:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.name}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Email:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.email}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Phone:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.phone}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Address:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.address}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Blood Group:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.bloodGroup || 'Not specified'}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Date of Birth:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.dob || 'Not specified'}</span>
//               </div>
//             </div>

//             <div style={styles.employeeDetailCard}>
//               <h3 style={styles.sectionHeading}>💼 Work Information</h3>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Role:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.userRole}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Login ID:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.loginId}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Login Type:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.loginType}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Assigned Location:</span>
//                 <span style={styles.detailValue}>{selectedEmployee.assignLocation || 'Not assigned'}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Branch:</span>
//                 <span style={styles.detailValue}>{resolveBranchName(selectedEmployee.branchId)}</span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Status:</span>
//                 <span style={styles.detailValue}>
//                   <span style={{ 
//                     color: selectedEmployee.active ? '#10b981' : '#ef4444',
//                     fontWeight: '600'
//                   }}>
//                     {selectedEmployee.active ? 'Active' : 'Inactive'}
//                   </span>
//                 </span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Superadmin:</span>
//                 <span style={styles.detailValue}>{currentUser.email}</span>
//               </div>
//             </div>

//             <div style={styles.employeeDetailCard}>
//               <h3 style={styles.sectionHeading}>⚙️ Permissions & Settings</h3>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Flat Discount:</span>
//                 <span style={styles.detailValue}>
//                   <span style={{ 
//                     color: selectedEmployee.flatDiscount ? '#10b981' : '#ef4444',
//                     fontWeight: '600'
//                   }}>
//                     {selectedEmployee.flatDiscount ? 'Enabled' : 'Disabled'}
//                   </span>
//                 </span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Day End Denomination:</span>
//                 <span style={styles.detailValue}>
//                   <span style={{ 
//                     color: selectedEmployee.dayEndDenomination ? '#10b981' : '#ef4444',
//                     fontWeight: '600'
//                   }}>
//                     {selectedEmployee.dayEndDenomination ? 'Enabled' : 'Disabled'}
//                   </span>
//                 </span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Created Date:</span>
//                 <span style={styles.detailValue}>
//                   {selectedEmployee.createdAt ? 
//                     new Date(selectedEmployee.createdAt).toLocaleDateString('en-US', {
//                       year: 'numeric',
//                       month: 'long',
//                       day: 'numeric',
//                       hour: '2-digit',
//                       minute: '2-digit'
//                     }) : 
//                     'Not available'
//                   }
//                 </span>
//               </div>
//               <div style={styles.detailRow}>
//                 <span style={styles.detailLabel}>Firebase UID:</span>
//                 <span style={styles.detailValue}>
//                   {selectedEmployee.firebaseUid ? 
//                     selectedEmployee.firebaseUid.substring(0, 8) + '...' : 
//                     'Not available'
//                   }
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Employee Activity Log Section */}
//           <div style={styles.employeeDetailCard}>
//             <h3 style={styles.sectionHeading}>📊 Employee Activity Summary</h3>
//             <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
//               <div style={{ 
//                 backgroundColor: '#dbeafe', 
//                 padding: '1rem', 
//                 borderRadius: '8px',
//                 textAlign: 'center'
//               }}>
//                 <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#2563eb' }}>0</div>
//                 <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>Total Logins</div>
//               </div>
//               <div style={{ 
//                 backgroundColor: '#dcfce7', 
//                 padding: '1rem', 
//                 borderRadius: '8px',
//                 textAlign: 'center'
//               }}>
//                 <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#16a34a' }}>0</div>
//                 <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>Transactions</div>
//               </div>
//               <div style={{ 
//                 backgroundColor: '#fef3c7', 
//                 padding: '1rem', 
//                 borderRadius: '8px',
//                 textAlign: 'center'
//               }}>
//                 <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#d97706' }}>0</div>
//                 <div style={styles.branchInfo}>Reports Generated</div>
//               </div>
//               <div style={{ 
//                 backgroundColor: '#fce7f3', 
//                 padding: '1rem', 
//                 borderRadius: '8px',
//                 textAlign: 'center'
//               }}>
//                 <div style={{ fontSize: '1.5rem', fontWeight: '700', color: '#be185d' }}>
//                   {selectedEmployee.active ? 'Online' : 'Offline'}
//                 </div>
//                 <div style={{ fontSize: '0.8rem', color: '#6b7280' }}>Current Status</div>
//               </div>
//             </div>
//           </div>

//           <div style={styles.actionButtons}>
//             <button
//               style={{ 
//                 ...styles.actionButton, 
//                 backgroundColor: '#2563eb', 
//                 color: 'white',
//                 boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)'
//               }}
//               onClick={() => {
//                 // Add edit functionality here
//                 alert('Edit functionality will be implemented');
//                 setShowEmployeeDetails(false);
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(37, 99, 235, 0.3)';
//               }}
//             >
//               ✏️ Edit Employee
//             </button>
//             <button
//               style={{ 
//                 ...styles.actionButton, 
//                 backgroundColor: selectedEmployee.active ? '#ef4444' : '#10b981', 
//                 color: 'white',
//                 boxShadow: `0 2px 8px ${selectedEmployee.active ? 'rgba(239, 68, 68, 0.3)' : 'rgba(16, 185, 129, 0.3)'}`
//               }}
//               onClick={() => {
//                 const action = selectedEmployee.active ? 'deactivate' : 'activate';
//                 if (window.confirm(`Are you sure you want to ${action} this employee?`)) {
//                   alert(`${action.charAt(0).toUpperCase() + action.slice(1)} functionality will be implemented`);
//                 }
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 const color = selectedEmployee.active ? 'rgba(239, 68, 68, 0.4)' : 'rgba(16, 185, 129, 0.4)';
//                 e.target.style.boxShadow = `0 4px 12px ${color}`;
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 const color = selectedEmployee.active ? 'rgba(239, 68, 68, 0.3)' : 'rgba(16, 185, 129, 0.3)';
//                 e.target.style.boxShadow = `0 2px 8px ${color}`;
//               }}
//             >
//               {selectedEmployee.active ? '🚫 Deactivate' : '✅ Activate'}
//             </button>
//             <button
//               style={{ 
//                 ...styles.actionButton, 
//                 backgroundColor: '#f59e0b', 
//                 color: 'white',
//                 boxShadow: '0 2px 8px rgba(245, 158, 11, 0.3)'
//               }}
//               onClick={() => {
//                 alert('Reset password functionality will be implemented');
//               }}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(245, 158, 11, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(245, 158, 11, 0.3)';
//               }}
//             >
//               🔑 Reset Password
//             </button>
//             <button
//               style={{ 
//                 ...styles.actionButton, 
//                 backgroundColor: '#6b7280', 
//                 color: 'white',
//                 boxShadow: '0 2px 8px rgba(107, 114, 128, 0.3)'
//               }}
//               onClick={() => setShowEmployeeDetails(false)}
//               onMouseEnter={(e) => {
//                 e.target.style.transform = 'translateY(-1px)';
//                 e.target.style.boxShadow = '0 4px 12px rgba(107, 114, 128, 0.4)';
//               }}
//               onMouseLeave={(e) => {
//                 e.target.style.transform = 'translateY(0)';
//                 e.target.style.boxShadow = '0 2px 8px rgba(107, 114, 128, 0.3)';
//               }}
//             >
//               ❌ Close
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default ManageEmployeeRole;



// import React, { useState, useEffect, useCallback } from 'react';
// import { database, ref, onValue, push, set, update, auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from '../firebase';
// import globalSyncService from '../Services/GlobalSyncService';

// const ManageEmployeeRole = () => {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [active, setActive] = useState(true);
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [address, setAddress] = useState('');
//   const [phone, setPhone] = useState('');
//   const [bloodGroup, setBloodGroup] = useState('');
//   const [dob, setDob] = useState('');
//   const [userRole, setUserRole] = useState('');
//   const [loginType, setLoginType] = useState('Main Login');
//   const [assignLocation, setAssignLocation] = useState('');
//   const [flatDiscount, setFlatDiscount] = useState(false);
//   const [dayEndDenomination, setDayEndDenomination] = useState(false);
//   const [password, setPassword] = useState('');
//   const [retypePassword, setRetypePassword] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [showEmployeeForm, setShowEmployeeForm] = useState(false);
//   const [showBranchForm, setShowBranchForm] = useState(false);
//   const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [isSyncing, setIsSyncing] = useState(false);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   // Branch form states
//   const [branchName, setBranchName] = useState('');
//   const [branchAddress, setBranchAddress] = useState('');
//   const [branchPhone, setBranchPhone] = useState('');
//   const [branchEmail, setBranchEmail] = useState('');
//   const [branchManager, setBranchManager] = useState('');
//   const [branchUserEmail, setBranchUserEmail] = useState('');
//   const [branchUserPassword, setBranchUserPassword] = useState('');
//   const [branchUserRetypePassword, setBranchUserRetypePassword] = useState('');

//   // Data structure paths that need to be synced
//   const SYNC_PATHS = [
//     'products',
//     'categories',
//     'brands',
//     'customers',
//     'invoices',
//     'suppliers',
//     'inventory',
//     'reports',
//     'settings',
//     'companyInfo',
//     'taxSettings',
//     'paymentMethods',
//     'discountSettings'
//   ];

//   // Monitor authentication state
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setCurrentUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Check employee access restrictions
//   const checkEmployeeAccess = useCallback((currentUserEmail, requestedPath) => {
//     const restrictedPaths = ['employees', 'branches'];
//     return new Promise((resolve) => {
//       const userKey = currentUserEmail.replace(/\./g, '_');
//       const profileRef = ref(database, `users/${userKey}/profile`);
//       onValue(profileRef, (snapshot) => {
//         const profileData = snapshot.val();
//         const isEmployee = profileData && profileData.isEmployee;
//         if (isEmployee && restrictedPaths.includes(requestedPath)) {
//           console.log(`🚫 Access denied: Employee ${currentUserEmail} cannot access ${requestedPath}`);
//           resolve(false);
//         } else {
//           resolve(true);
//         }
//       }, { onlyOnce: true });
//     });
//   }, []);

//   // Copy all data to employee (excluding employee and branch management data)
//   const copyAllDataToEmployee = useCallback(async (adminEmail, employeeEmail) => {
//     try {
//       setIsSyncing(true);
//       const adminKey = adminEmail.replace(/\./g, '_');
//       const employeeKey = employeeEmail.replace(/\./g, '_');
//       console.log(`🚀 Starting selective data copy from ${adminEmail} to ${employeeEmail} (excluding employee and branch management)...`);
//       if (currentUser.email !== adminEmail) {
//         console.log('🚫 Data sync denied: Only admin can sync data to new employees');
//         return false;
//       }
//       const adminDataRef = ref(database, `users/${adminKey}`);
//       const adminSnapshot = await new Promise((resolve, reject) => {
//         onValue(adminDataRef, resolve, { onlyOnce: true });
//         setTimeout(() => reject(new Error('Timeout fetching admin data')), 10000);
//       });
//       const adminData = adminSnapshot.val();
//       if (adminData) {
//         const employeeProfile = {
//           role: 'employee',
//           isEmployee: true,
//           adminEmail: adminEmail,
//           adminEmailKey: adminKey,
//           canAccessAdminData: true,
//           inheritedFrom: adminEmail,
//           personalInfo: {
//             name,
//             email: employeeEmail,
//             address,
//             phone,
//             bloodGroup,
//             dob,
//             userRole,
//             active,
//             loginType,
//             assignLocation,
//             flatDiscount,
//             dayEndDenomination,
//           },
//           createdAt: new Date().toISOString(),
//           lastSyncWith: adminKey
//         };
//         await set(ref(database, `users/${employeeKey}/profile`), employeeProfile);
//         await set(ref(database, `users/${employeeKey}/syncMetadata`), {
//           isEmployee: true,
//           adminEmail: adminEmail,
//           lastFullSyncAt: new Date().toISOString(),
//           syncedPaths: SYNC_PATHS,
//           syncStatus: 'active',
//           autoSyncEnabled: true,
//           excludedPaths: ['employees', 'branches']
//         });
//         for (const path of SYNC_PATHS) {
//           if (adminData[path]) {
//             const pathRef = ref(database, `users/${employeeKey}/${path}`);
//             await set(pathRef, adminData[path]);
//             console.log(`✅ Copied ${path} to employee`);
//           }
//         }
//         console.log(`✅ Selective data copy completed (employee and branch management data excluded)`);
//         return true;
//       } else {
//         throw new Error('No admin data found to copy');
//       }
//     } catch (error) {
//       console.error('❌ Error copying data to employee:', error);
//       throw error;
//     } finally {
//       setIsSyncing(false);
//     }
//   }, [name, email, address, phone, bloodGroup, dob, userRole, active, loginType, assignLocation, flatDiscount, dayEndDenomination, currentUser]);

//   // Handle add employee
//   const handleAddEmployee = async (e) => {
//     e.preventDefault();
//     setMessage('');
//     setMessageType('');
//     if (password !== retypePassword) {
//       setMessage("Passwords don't match!");
//       setMessageType('error');
//       return;
//     }
//     const adminPassword = prompt("Please enter your admin password to create employee account:");
//     if (!adminPassword) {
//       setMessage("Password confirmation required to create employee account.");
//       setMessageType('error');
//       return;
//     }
//     if (name && email && address && phone && userRole && password && currentUser) {
//       try {
//         const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//         if (!hasAccess) {
//           setMessage('Access denied: You do not have permission to manage employees.');
//           setMessageType('error');
//           return;
//         }
//         setIsSyncing(true);
//         try {
//           await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
//         } catch (error) {
//           throw new Error('Invalid admin password. Please try again.');
//         }
//         const adminEmail = currentUser.email;
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         await signOut(auth);
//         await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
//         const adminEmailKey = adminEmail.replace(/\./g, '_');
//         const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
//         const employeeData = {
//           active,
//           name,
//           email,
//           address,
//           phone,
//           bloodGroup,
//           dob,
//           userRole,
//           loginType,
//           assignLocation,
//           flatDiscount,
//           dayEndDenomination,
//           createdAt: new Date().toISOString(),
//           createdBy: adminEmail,
//           adminEmail: adminEmail,
//           firebaseUid: userCredential.user.uid,
//           syncStatus: 'pending',
//           autoSyncEnabled: true
//         };
//         const newEmployeeRef = await push(employeesRef, employeeData);
//         await copyAllDataToEmployee(adminEmail, email);
//         const empUpdateRef = ref(database, `users/${adminEmailKey}/employees/${newEmployeeRef.key}`);
//         await update(empUpdateRef, {
//           syncStatus: 'synced',
//           lastSyncAt: new Date().toISOString(),
//           globalSyncActive: true
//         });
//         setTimeout(() => {
//           globalSyncService.refreshSync();
//         }, 1000);
//         setTimeout(() => {
//           globalSyncService.ensureSyncActive();
//         }, 3000);
//         setTimeout(() => {
//           globalSyncService.initializeGlobalSync();
//         }, 5000);
//         handleResetForm();
//         setShowEmployeeForm(false);
//         setMessage(`Employee "${name}" added successfully! Real-time bidirectional sync is active.`);
//         setMessageType('success');
//       } catch (error) {
//         console.error("❌ Error adding employee: ", error);
//         setMessage(`Failed to add employee: ${error.message}`);
//         setMessageType('error');
//       } finally {
//         setIsSyncing(false);
//       }
//     } else {
//       setMessage("Please fill in all required fields!");
//       setMessageType('error');
//     }
//   };

// const handleAddBranch = async (e) => {
//   e.preventDefault();
//   setMessage('');
//   setMessageType('');
//   if (branchUserPassword !== branchUserRetypePassword) {
//     setMessage("Branch user passwords don't match!");
//     setMessageType('error');
//     return;
//   }
//   const adminPassword = prompt("Please enter your admin password to create branch account:");
//   if (!adminPassword) {
//     setMessage("Password confirmation required to create branch account.");
//     setMessageType('error');
//     return;
//   }
//   if (branchName && branchAddress && branchUserEmail && branchUserPassword && currentUser) {
//     try {
//       const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
//       if (!hasAccess) {
//         setMessage('Access denied: You do not have permission to manage branches.');
//         setMessageType('error');
//         return;
//       }
//       setIsSyncing(true);
//       try {
//         await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
//       } catch (error) {
//         throw new Error('Invalid admin password. Please try again.');
//       }
//       const adminEmail = currentUser.email;
//       const userCredential = await createUserWithEmailAndPassword(auth, branchUserEmail, branchUserPassword);
//       await signOut(auth);
//       await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
//       const adminEmailKey = adminEmail.replace(/\./g, '_');
//       const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
//       const newBranchData = {
//         name: branchName,
//         address: branchAddress,
//         phone: branchPhone,
//         email: branchEmail,
//         manager: branchManager,
//         userEmail: branchUserEmail,
//         firebaseUid: userCredential.user.uid,
//         createdAt: new Date().toISOString(),
//         createdBy: adminEmail,
//         active: true,
//         autoSyncEnabled: false
//       };
//       await push(branchesRef, newBranchData);
//       const branchKey = branchUserEmail.replace(/\./g, '_');
//       const branchProfile = {
//         role: 'branch',
//         isBranch: true,
//         adminEmail: adminEmail,
//         adminEmailKey: adminEmailKey,
//         canAccessAdminData: true, // Allow full data access
//         branchInfo: {
//           name: branchName,
//           address: branchAddress,
//           phone: branchPhone,
//           email: branchEmail,
//           manager: branchManager,
//           userEmail: branchUserEmail
//         },
//         createdAt: new Date().toISOString(),
//         autoSyncEnabled: false
//       };
//       await set(ref(database, `users/${branchKey}/profile`), branchProfile);
//       // Copy all business data to branch
//       await copyAllDataToEmployee(adminEmail, branchUserEmail); // Reuse the same function to copy data
//       setBranchName('');
//       setBranchAddress('');
//       setBranchPhone('');
//       setBranchEmail('');
//       setBranchManager('');
//       setBranchUserEmail('');
//       setBranchUserPassword('');
//       setBranchUserRetypePassword('');
//       setShowBranchForm(false);
//       setMessage('Branch and user account created successfully with full access!');
//       setMessageType('success');
//     } catch (error) {
//       console.error("❌ Error adding branch: ", error);
//       setMessage(`Failed to add branch: ${error.message}`);
//       setMessageType('error');
//     } finally {
//       setIsSyncing(false);
//     }
//   } else {
//     setMessage("Please fill in all required fields including user credentials!");
//     setMessageType('error');
//   }
// };

//   // Load employees, branches, and roles
//   useEffect(() => {
//     if (currentUser) {
//       console.log('📋 ManageEmployeeRole loaded - ensuring global sync is active...');
//       setTimeout(() => {
//         globalSyncService.ensureSyncActive();
//       }, 500);
//       const adminEmailKey = currentUser.email.replace(/\./g, '_');
//       checkEmployeeAccess(currentUser.email, 'employees').then(hasAccess => {
//         if (hasAccess) {
//           const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
//           const unsubscribeEmployees = onValue(employeesRef, (snapshot) => {
//             const data = snapshot.val();
//             const employeesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
//             setEmployees(employeesList);
//           }, {
//             errorCallback: (error) => {
//               console.error('Error loading employees:', error);
//               setMessage('Failed to load employees: ' + error.message);
//               setMessageType('error');
//             }
//           });
//           return () => unsubscribeEmployees();
//         }
//       });
//       const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
//       const unsubscribeBranches = onValue(branchesRef, (snapshot) => {
//         const data = snapshot.val();
//         const branchesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
//         setBranches(branchesList);
//       }, {
//         errorCallback: (error) => {
//           console.error('Error loading branches:', error);
//           setMessage('Failed to load branches: ' + error.message);
//           setMessageType('error');
//         }
//       });
//       const rolesRef = ref(database, `users/${adminEmailKey}/roles`);
//       const unsubscribeRoles = onValue(rolesRef, (snapshot) => {
//         const data = snapshot.val();
//         const rolesList = data ? Object.values(data).map(role => role.roleName) : [];
//         setRoles(rolesList);
//       }, {
//         errorCallback: (error) => {
//           console.error('Error loading roles:', error);
//           setMessage('Failed to load roles: ' + error.message);
//           setMessageType('error');
//         }
//       });
//       return () => {
//         unsubscribeBranches();
//         unsubscribeRoles();
//       };
//     }
//   }, [currentUser, checkEmployeeAccess]);

//   const handleResetForm = () => {
//     setActive(true);
//     setName('');
//     setEmail('');
//     setAddress('');
//     setPhone('');
//     setBloodGroup('');
//     setDob('');
//     setUserRole('');
//     setLoginType('Main Login');
//     setAssignLocation('');
//     setFlatDiscount(false);
//     setDayEndDenomination(false);
//     setPassword('');
//     setRetypePassword('');
//   };

//   const handleEmployeeClick = async (employee) => {
//     const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//     if (hasAccess) {
//       setSelectedEmployee(employee);
//       setShowEmployeeDetails(true);
//     } else {
//       setMessage('Access denied: You do not have permission to view employee details.');
//       setMessageType('error');
//     }
//   };

//   const handleCancel = () => {
//     handleResetForm();
//     setShowEmployeeForm(false);
//     setShowBranchForm(false);
//     setMessage('');
//     setMessageType('');
//   };

//   // Styles matching CustomerForm
//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '2rem auto',
//       padding: '2rem',
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//       minHeight: '100vh',
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '20px',
//       padding: '2.5rem',
//       border: '1px solid #e2e8f0',
//     },
//     heading: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       marginBottom: '2rem',
//       color: '#1f2937',
//       textAlign: 'center',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     loadingContainer: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#6b7280',
//     },
//     loadingSpinner: {
//       width: '3rem',
//       height: '3rem',
//       border: '4px solid #e5e7eb',
//       borderTop: '4px solid #2563eb',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//       margin: '0 auto 1rem',
//     },
//     formLayout: {
//       display: 'grid',
//       gridTemplateColumns: '1fr',
//       gap: '2rem',
//     },
//     twoColumnLayout: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
//       gap: '2rem',
//     },
//     section: {
//       backgroundColor: '#fff',
//       padding: '1.5rem',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//     },
//     sectionHeading: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.875rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '90%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     checkboxContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     checkbox: {
//       width: '1rem',
//       height: '1rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '4px',
//       cursor: 'pointer',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     button: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//     },
//     submitButton: {
//       backgroundColor: '#10b981',
//       color: 'white',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//     },
//     gridTwoColumns: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//       gap: '1rem',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '1.5rem',
//       flexWrap: 'wrap',
//       gap: '1rem',
//     },
//     headerTitle: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       color: '#2563eb',
//     },
//     headerButtons: {
//       display: 'flex',
//       gap: '0.5rem',
//       flexWrap: 'wrap',
//       alignItems: 'center',
//     },
//     addButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '500',
//       cursor: isSyncing ? 'not-allowed' : 'pointer',
//       border: 'none',
//       fontSize: '0.875rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
//     },
//     branchButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: isSyncing ? 'not-allowed' : 'pointer',
//       border: 'none',
//       fontSize: '0.875rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//     },
//     tableContainer: {
//       marginTop: '1rem',
//       overflowX: 'auto',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.875rem',
//     },
//     tableHeader: {
//       padding: '0.75rem',
//       textAlign: 'center',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.875rem',
//       textTransform: 'uppercase',
//       border: '1px solid #1e40af',
//     },
//     tableCell: {
//       padding: '0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       textAlign: 'center',
//       cursor: 'pointer',
//     },
//     branchCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '0.5rem 0',
//     },
//     branchName: {
//       fontSize: '1rem',
//       fontWeight: '600',
//       color: '#1f2937',
//       marginBottom: '0.5rem',
//     },
//     branchInfo: {
//       fontSize: '0.875rem',
//       color: '#6b7280',
//       marginBottom: '0.25rem',
//     },
//     employeeDetailCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1.5rem',
//       margin: '1rem 0',
//     },
//     detailRow: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       padding: '0.5rem 0',
//       borderBottom: '1px solid #e2e8f0',
//     },
//     detailLabel: {
//       fontWeight: '600',
//       color: '#374151',
//     },
//     detailValue: {
//       color: '#6b7280',
//     },
//     infoCard: {
//       backgroundColor: '#dbeafe',
//       border: '1px solid #93c5fd',
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '1rem 0',
//       color: '#1e40af',
//     },
//     syncStatusCard: {
//       backgroundColor: isSyncing ? '#fef3c7' : '#dcfce7',
//       border: `1px solid ${isSyncing ? '#fbbf24' : '#86efac'}`,
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '1rem 0',
//       color: isSyncing ? '#d97706' : '#15803d',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     spinner: {
//       width: '1rem',
//       height: '1rem',
//       border: '2px solid transparent',
//       borderTop: '2px solid currentColor',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//     },
//   };

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.formWrapper}>
//           <div style={styles.loadingContainer}>
//             <p>Please log in to access employee management.</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <style jsx>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           .twoColumnLayout {
//             grid-template-columns: 1fr;
//           }
//           .gridTwoColumns {
//             grid-template-columns: 1fr;
//           }
//           .buttonContainer {
//             flex-direction: column;
//           }
//           .button {
//             width: 100%;
//             justify-content: center;
//           }
//         }
//         input:focus,
//         select:focus {
//           outline: none;
//           border-color: #2563eb;
//           box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
//         }
//         input:hover,
//         select:hover {
//           border-color: #a1a1aa;
//         }
//         button:hover:not(:disabled) {
//           filter: brightness(90%);
//         }
//       `}</style>
//       <div style={styles.formWrapper}>
//         {showEmployeeForm ? (
//           <>
//             <h1 style={styles.heading}>👤 Add New Employee</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {isSyncing ? (
//               <div style={styles.loadingContainer}>
//                 <div style={styles.loadingSpinner}></div>
//                 <p>Creating employee and syncing data...</p>
//               </div>
//             ) : (
//               <form onSubmit={handleAddEmployee}>
//                 <div style={styles.formLayout}>
//                   <div style={styles.twoColumnLayout}>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>📋 Personal Details</h2>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={active}
//                             onChange={(e) => setActive(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Active</label>
//                         </div>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={name}
//                           onChange={(e) => setName(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter name"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Email<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter email"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Address<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={address}
//                           onChange={(e) => setAddress(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter address"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Phone No.<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={phone}
//                           onChange={(e) => setPhone(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter phone number"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Blood Group</label>
//                         <input
//                           type="text"
//                           value={bloodGroup}
//                           onChange={(e) => setBloodGroup(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter blood group"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Date of Birth</label>
//                         <input
//                           type="date"
//                           value={dob}
//                           onChange={(e) => setDob(e.target.value)}
//                           style={styles.input}
//                         />
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔑 Login Details</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Role Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <select
//                           value={userRole}
//                           onChange={(e) => setUserRole(e.target.value)}
//                           style={styles.select}
//                           required
//                         >
//                           <option value="">Select Role</option>
//                           {roles.map((role) => (
//                             <option key={role} value={role}>
//                               {role}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Login Type</label>
//                         <select
//                           value={loginType}
//                           onChange={(e) => setLoginType(e.target.value)}
//                           style={styles.select}
//                         >
//                           <option value="Main Login">Main Login</option>
//                           <option value="Sub Login">Sub Login</option>
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Assign Location</label>
//                         <select
//                           value={assignLocation}
//                           onChange={(e) => setAssignLocation(e.target.value)}
//                           style={styles.select}
//                         >
//                           <option value="">Select Location</option>
//                           {branches.map((branch) => (
//                             <option key={branch.id} value={branch.name}>
//                               {branch.name}
//                             </option>
//                           ))}
//                           <option value="WAREHOUSE/Warehouse/Puduche">WAREHOUSE/Warehouse/Puduche</option>
//                           <option value="STORE/Store/CITY">STORE/Store/CITY</option>
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={flatDiscount}
//                             onChange={(e) => setFlatDiscount(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Flat Discount</label>
//                         </div>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={dayEndDenomination}
//                             onChange={(e) => setDayEndDenomination(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Day End Denomination</label>
//                         </div>
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔒 Credentials</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter password"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Retype Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={retypePassword}
//                           onChange={(e) => setRetypePassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Retype password"
//                           required
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={styles.buttonContainer}>
//                   <button
//                     type="button"
//                     onClick={handleCancel}
//                     style={{ ...styles.button, ...styles.cancelButton }}
//                     disabled={isSyncing}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     style={{ ...styles.button, ...styles.submitButton }}
//                     disabled={isSyncing}
//                   >
//                     Add Employee
//                   </button>
//                 </div>
//               </form>
//             )}
//           </>
//         ) : showBranchForm ? (
//           <>
//             <h1 style={styles.heading}>🏢 Add New Branch</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {isSyncing ? (
//               <div style={styles.loadingContainer}>
//                 <div style={styles.loadingSpinner}></div>
//                 <p>Creating branch and syncing data...</p>
//               </div>
//             ) : (
//               <form onSubmit={handleAddBranch}>
//                 <div style={styles.formLayout}>
//                   <div style={styles.twoColumnLayout}>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🏢 Branch Details</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Branch Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={branchName}
//                           onChange={(e) => setBranchName(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter branch name"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Address<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={branchAddress}
//                           onChange={(e) => setBranchAddress(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter address"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Phone</label>
//                         <input
//                           type="text"
//                           value={branchPhone}
//                           onChange={(e) => setBranchPhone(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter phone number"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Email</label>
//                         <input
//                           type="email"
//                           value={branchEmail}
//                           onChange={(e) => setBranchEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter email"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Manager</label>
//                         <input
//                           type="text"
//                           value={branchManager}
//                           onChange={(e) => setBranchManager(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter manager name"
//                         />
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔒 Branch User Credentials</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           User Email<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="email"
//                           value={branchUserEmail}
//                           onChange={(e) => setBranchUserEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter user email for branch login"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           User Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={branchUserPassword}
//                           onChange={(e) => setBranchUserPassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter user password"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Retype User Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={branchUserRetypePassword}
//                           onChange={(e) => setBranchUserRetypePassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Retype user password"
//                           required
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={styles.buttonContainer}>
//                   <button
//                     type="button"
//                     onClick={handleCancel}
//                     style={{ ...styles.button, ...styles.cancelButton }}
//                     disabled={isSyncing}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     style={{ ...styles.button, ...styles.submitButton }}
//                     disabled={isSyncing}
//                   >
//                     Add Branch
//                   </button>
//                 </div>
//               </form>
//             )}
//           </>
//         ) : showEmployeeDetails && selectedEmployee ? (
//           <>
//             <h1 style={styles.heading}>👤 Employee Details - {selectedEmployee.name}</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             <div style={styles.formLayout}>
//               <div style={styles.twoColumnLayout}>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>👤 Personal Information</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Name</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.name}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Email</label>
//                     <input
//                       type="email"
//                       value={selectedEmployee.email}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Phone</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.phone}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Address</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.address}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Blood Group</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.bloodGroup || 'Not specified'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Date of Birth</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.dob || 'Not specified'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>💼 Work Information</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Role</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.userRole}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Login Type</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.loginType}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Assigned Location</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.assignLocation || 'Not assigned'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Status</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.active ? 'Active' : 'Inactive'}
//                       style={{ ...styles.input, color: selectedEmployee.active ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Admin Email</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.adminEmail}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Sync Status</label>
//                     <input
//                       type="text"
//                       value={
//                         selectedEmployee.syncStatus === 'synced'
//                           ? 'Real-time Sync Active'
//                           : selectedEmployee.syncStatus === 'pending'
//                           ? 'Sync Pending'
//                           : 'Bidirectional Sync'
//                       }
//                       style={{
//                         ...styles.input,
//                         color:
//                           selectedEmployee.syncStatus === 'synced'
//                             ? '#10b981'
//                             : selectedEmployee.syncStatus === 'pending'
//                             ? '#f59e0b'
//                             : '#2563eb'
//                       }}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>⚙️ Permissions & Settings</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Flat Discount</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.flatDiscount ? 'Enabled' : 'Disabled'}
//                       style={{ ...styles.input, color: selectedEmployee.flatDiscount ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Day End Denomination</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.dayEndDenomination ? 'Enabled' : 'Disabled'}
//                       style={{ ...styles.input, color: selectedEmployee.dayEndDenomination ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Data Access Level</label>
//                     <input
//                       type="text"
//                       value="Full Business Data (Excluding Employee & Branch Management)"
//                       style={{ ...styles.input, color: '#10b981' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Created Date</label>
//                     <input
//                       type="text"
//                       value={
//                         selectedEmployee.createdAt
//                           ? new Date(selectedEmployee.createdAt).toLocaleDateString('en-US', {
//                               year: 'numeric',
//                               month: 'long',
//                               day: 'numeric',
//                               hour: '2-digit',
//                               minute: '2-digit'
//                             })
//                           : 'Not available'
//                       }
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Firebase UID</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.firebaseUid ? selectedEmployee.firebaseUid.substring(0, 8) + '...' : 'Not available'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Sync Type</label>
//                     <input
//                       type="text"
//                       value="Bidirectional Real-time (Business Data Only)"
//                       style={{ ...styles.input, color: '#8b5cf6' }}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h2 style={styles.sectionHeading}>📊 Real-time Data Access & Sync Status</h2>
//                 <div style={{ marginBottom: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
//                   All business data changes are automatically synchronized in real-time between admin and employee accounts (excluding employee and branch management data).
//                 </div>
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
//                   {SYNC_PATHS.map((path, index) => (
//                     <div
//                       key={path}
//                       style={{
//                         backgroundColor: ['#dbeafe', '#dcfce7', '#fef3c7', '#fce7f3', '#f3e8ff', '#ecfdf5', '#fef2f2', '#f0fdfa'][index % 8],
//                         padding: '1rem',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                       }}
//                     >
//                       <div style={{ fontSize: '1.5rem', fontWeight: '700', color: ['#2563eb', '#16a34a', '#d97706', '#be185d', '#7c3aed', '#059669', '#dc2626', '#0d9488'][index % 8] }}>🔄</div>
//                       <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '600' }}>{path.charAt(0).toUpperCase() + path.slice(1)}</div>
//                       <div style={{ fontSize: '0.75rem', color: '#10b981', marginTop: '0.25rem' }}>Real-time Sync</div>
//                     </div>
//                   ))}
//                 </div>
//                 <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
//                   <h4 style={{ margin: '0 0 0.75rem 0', fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>
//                     🔄 Bidirectional Sync Flow
//                   </h4>
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
//                     <div style={{ padding: '0.5rem 1rem', backgroundColor: '#2563eb', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
//                       {selectedEmployee.adminEmail}
//                     </div>
//                     <div style={{ fontSize: '1.2rem' }}>↔️</div>
//                     <div style={{ padding: '0.5rem 1rem', backgroundColor: '#10b981', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
//                       {selectedEmployee.email}
//                     </div>
//                   </div>
//                   <div style={{ textAlign: 'center', fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
//                     Real-time bidirectional data synchronization active (business data only)
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div style={styles.buttonContainer}>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#2563eb', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (hasAccess) {
//                     setMessage('Edit functionality will be implemented');
//                     setMessageType('info');
//                     setShowEmployeeDetails(false);
//                   } else {
//                     setMessage('Access denied: You do not have permission to edit employees.');
//                     setMessageType('error');
//                   }
//                 }}
//               >
//                 ✏️ Edit Employee
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: selectedEmployee.active ? '#ef4444' : '#10b981', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (!hasAccess) {
//                     setMessage('Access denied: You do not have permission to modify employee status.');
//                     setMessageType('error');
//                     return;
//                   }
//                   const action = selectedEmployee.active ? 'deactivate' : 'activate';
//                   if (window.confirm(`Are you sure you want to ${action} this employee? This will affect their data sync status.`)) {
//                     setMessage(`${action.charAt(0).toUpperCase() + action.slice(1)} functionality will be implemented`);
//                     setMessageType('info');
//                   }
//                 }}
//               >
//                 {selectedEmployee.active ? '🚫 Deactivate' : '✅ Activate'}
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#f59e0b', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (!hasAccess) {
//                     setMessage('Access denied: You do not have permission to reset employee passwords.');
//                     setMessageType('error');
//                     return;
//                   }
//                   if (window.confirm('Reset password for this employee? They will need to use the new password to login. Data sync will remain active.')) {
//                     setMessage('Reset password functionality will be implemented');
//                     setMessageType('info');
//                   }
//                 }}
//               >
//                 🔑 Reset Password
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#6b7280', color: 'white' }}
//                 onClick={() => setShowEmployeeDetails(false)}
//               >
//                 ❌ Close
//               </button>
//             </div>
//           </>
//         ) : (
//           <>
//             <div style={styles.header}>
//               <div style={styles.headerTitle}>
//                 Manage Employee Role & Branches
//                 <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '400' }}>
//                   Logged in as: {currentUser.email}
//                 </div>
//               </div>
//               <div style={styles.headerButtons}>
//                 <button
//                   style={styles.addButton}
//                   onClick={async () => {
//                     const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                     if (hasAccess && !isSyncing) setShowEmployeeForm(true);
//                     else if (!hasAccess) {
//                       setMessage('Access denied: You do not have permission to add employees.');
//                       setMessageType('error');
//                     }
//                   }}
//                   disabled={isSyncing}
//                 >
//                   + Add Employee
//                 </button>
//                 <button
//                   style={styles.branchButton}
//                   onClick={async () => {
//                     const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
//                     if (hasAccess && !isSyncing) setShowBranchForm(true);
//                     else if (!hasAccess) {
//                       setMessage('Access denied: You do not have permission to add branches.');
//                       setMessageType('error');
//                     }
//                   }}
//                   disabled={isSyncing}
//                 >
//                   + Add Branch
//                 </button>
//               </div>
//             </div>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {/* <div style={styles.syncStatusCard}>
//               <div style={styles.spinner}></div>
//               <div>
//                 <strong>{isSyncing ? 'Auto-Sync In Progress...' : 'Global Real-time Bidirectional Sync Active'}</strong>
//                 <div style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
//                   {isSyncing
//                     ? 'Please wait while data is being synchronized automatically.'
//                     : 'All data changes are automatically synced globally in real-time across the entire application.'}
//                 </div>
//               </div>
//             </div> */}
//             {/* <div style={styles.infoCard}>
//               <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', fontWeight: '600' }}>
//                 📋 Global Automatic Data Synchronization System
//               </h3>
//               <p style={{ margin: '0', fontSize: '0.875rem', lineHeight: '1.4' }}>
//                 <strong>🚀 Global Automatic Features:</strong><br/>
//                 • <strong>Always Active:</strong> Sync works automatically across the entire app, not just this page<br/>
//                 • <strong>New Employees:</strong> Automatically receive ALL business data instantly upon creation<br/>
//                 • <strong>Real-time Sync:</strong> All business changes sync instantly across all users<br/>
//                 • <strong>Bidirectional:</strong> Data flows seamlessly between admin and all employee accounts<br/>
//                 • <strong>Background Operation:</strong> Works automatically without any user intervention<br/>
//                 • <strong>Business Data Auto-Synced:</strong> {SYNC_PATHS.join(', ')}<br/>
//                 • <strong>Admin-Only Data:</strong> Employee management, branch management, user roles, authentication settings
//               </p>
//             </div> */}
//             <div style={styles.section}>
//               <h2 style={styles.sectionHeading}>🏢 Branches ({branches.length})</h2>
//               {branches.length === 0 ? (
//                 <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//                   No branches added yet. Click "Add Branch" to create your first branch.
//                 </p>
//               ) : (
//                 <div style={styles.gridTwoColumns}>
//                   {branches.map((branch) => (
//                     <div key={branch.id} style={styles.branchCard}>
//                       <div style={styles.branchName}>{branch.name}</div>
//                       <div style={styles.branchInfo}>📍 {branch.address}</div>
//                       {branch.phone && <div style={styles.branchInfo}>📞 {branch.phone}</div>}
//                       {branch.email && <div style={styles.branchInfo}>📧 {branch.email}</div>}
//                       {branch.manager && <div style={styles.branchInfo}>👤 Manager: {branch.manager}</div>}
//                       <div style={{ fontSize: '0.75rem', color: '#10b981', fontWeight: '600', marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                     
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <div style={styles.section}>
//               <h2 style={styles.sectionHeading}>📋 Employee List ({employees.length})</h2>
//               {employees.length === 0 ? (
//                 <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//                   No employees added yet. Click "Add Employee" to add your first employee.
//                 </p>
//               ) : (
//                 <div style={styles.tableContainer}>
//                   <table style={styles.table}>
//                     <thead>
//                       <tr>
//                         <th style={styles.tableHeader}>ID</th>
//                         <th style={styles.tableHeader}>USER NAME</th>
//                         <th style={styles.tableHeader}>ROLE</th>
//                         <th style={styles.tableHeader}>EMAIL</th>
//                         <th style={styles.tableHeader}>ADMIN EMAIL</th>
//                         <th style={styles.tableHeader}>ASSIGNED LOCATION</th>
//                         <th style={styles.tableHeader}>SYNC STATUS</th>
//                         <th style={styles.tableHeader}>STATUS</th>
//                         <th style={styles.tableHeader}>ACTION</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {employees.map((employee, index) => (
//                         <tr
//                           key={employee.id}
//                           style={{ backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white' }}
//                           onClick={() => handleEmployeeClick(employee)}
//                         >
//                           <td style={styles.tableCell}>{index + 1}</td>
//                           <td style={styles.tableCell}>{employee.name}</td>
//                           <td style={styles.tableCell}>{employee.userRole}</td>
//                           <td style={styles.tableCell}>{employee.email}</td>
//                           <td style={styles.tableCell}>{employee.adminEmail}</td>
//                           <td style={styles.tableCell}>{employee.assignLocation || 'Not assigned'}</td>
//                           <td style={styles.tableCell}>
//                             <span style={{
//                               color: employee.syncStatus === 'synced' ? '#10b981' : employee.syncStatus === 'pending' ? '#f59e0b' : '#6b7280',
//                               fontWeight: '600'
//                             }}>
//                               {employee.syncStatus === 'synced' ? '✅ Synced' : employee.syncStatus === 'pending' ? '⏳ Pending' : '🔄 Active'}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{ color: employee.active ? '#10b981' : '#ef4444', fontWeight: '600' }}>
//                               {employee.active ? 'Active' : 'Inactive'}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{ color: '#f44336', cursor: 'pointer' }}>✏️</span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ManageEmployeeRole;

// import React, { useState, useEffect, useCallback } from 'react';
// import { database, ref, onValue, push, set, update, auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from '../firebase';
// import globalSyncService from '../Services/GlobalSyncService';

// const ManageEmployeeRole = () => {
//   const [currentUser, setCurrentUser] = useState(null);
//   const [active, setActive] = useState(true);
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [address, setAddress] = useState('');
//   const [phone, setPhone] = useState('');
//   const [bloodGroup, setBloodGroup] = useState('');
//   const [dob, setDob] = useState('');
//   const [userRole, setUserRole] = useState('');
//   const [loginType, setLoginType] = useState('Main Login');
//   const [assignLocation, setAssignLocation] = useState('');
//   const [flatDiscount, setFlatDiscount] = useState(false);
//   const [dayEndDenomination, setDayEndDenomination] = useState(false);
//   const [password, setPassword] = useState('');
//   const [retypePassword, setRetypePassword] = useState('');
//   const [employees, setEmployees] = useState([]);
//   const [branches, setBranches] = useState([]);
//   const [roles, setRoles] = useState([]);
//   const [showEmployeeForm, setShowEmployeeForm] = useState(false);
//   const [showBranchForm, setShowBranchForm] = useState(false);
//   const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);
//   const [selectedEmployee, setSelectedEmployee] = useState(null);
//   const [isSyncing, setIsSyncing] = useState(false);
//   const [message, setMessage] = useState('');
//   const [messageType, setMessageType] = useState('');

//   // Branch form states
//   const [branchName, setBranchName] = useState('');
//   const [branchAddress, setBranchAddress] = useState('');
//   const [branchPhone, setBranchPhone] = useState('');
//   const [branchEmail, setBranchEmail] = useState('');
//   const [branchManager, setBranchManager] = useState('');
//   const [branchUserEmail, setBranchUserEmail] = useState('');
//   const [branchUserPassword, setBranchUserPassword] = useState('');
//   const [branchUserRetypePassword, setBranchUserRetypePassword] = useState('');

//   // Data structure paths that need to be synced
//   const SYNC_PATHS = [
//     'products',
//     'categories',
//     'brands',
//     'customers',
//     'invoices',
//     'suppliers',
//     'inventory',
//     'reports',
//     'settings',
//     'companyInfo',
//     'taxSettings',
//     'paymentMethods',
//     'discountSettings'
//   ];

//   // Monitor authentication state
//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       setCurrentUser(user);
//     });
//     return () => unsubscribe();
//   }, []);

//   // Check employee access restrictions
//   const checkEmployeeAccess = useCallback((currentUserEmail, requestedPath) => {
//     const restrictedPaths = ['employees', 'branches'];
//     return new Promise((resolve) => {
//       const userKey = currentUserEmail.replace(/\./g, '_');
//       const profileRef = ref(database, `users/${userKey}/profile`);
//       onValue(profileRef, (snapshot) => {
//         const profileData = snapshot.val();
//         const isEmployee = profileData && profileData.isEmployee;
//         if (isEmployee && restrictedPaths.includes(requestedPath)) {
//           console.log(`🚫 Access denied: Employee ${currentUserEmail} cannot access ${requestedPath}`);
//           resolve(false);
//         } else {
//           resolve(true);
//         }
//       }, { onlyOnce: true });
//     });
//   }, []);

//   // Copy all data to employee (excluding employee and branch management data)
//   const copyAllDataToEmployee = useCallback(async (adminEmail, employeeEmail) => {
//     try {
//       setIsSyncing(true);
//       const adminKey = adminEmail.replace(/\./g, '_');
//       const employeeKey = employeeEmail.replace(/\./g, '_');
//       console.log(`🚀 Starting selective data copy from ${adminEmail} to ${employeeEmail} (excluding employee and branch management)...`);
//       if (currentUser.email !== adminEmail) {
//         console.log('🚫 Data sync denied: Only admin can sync data to new employees');
//         return false;
//       }
//       const adminDataRef = ref(database, `users/${adminKey}`);
//       const adminSnapshot = await new Promise((resolve, reject) => {
//         onValue(adminDataRef, resolve, { onlyOnce: true });
//         setTimeout(() => reject(new Error('Timeout fetching admin data')), 10000);
//       });
//       const adminData = adminSnapshot.val();
//       if (adminData) {
//         const employeeProfile = {
//           role: 'employee',
//           isEmployee: true,
//           adminEmail: adminEmail,
//           adminEmailKey: adminKey,
//           canAccessAdminData: true,
//           inheritedFrom: adminEmail,
//           personalInfo: {
//             name,
//             email: employeeEmail,
//             address,
//             phone,
//             bloodGroup,
//             dob,
//             userRole,
//             active,
//             loginType,
//             assignLocation,
//             flatDiscount,
//             dayEndDenomination,
//           },
//           createdAt: new Date().toISOString(),
//           lastSyncWith: adminKey
//         };
//         await set(ref(database, `users/${employeeKey}/profile`), employeeProfile);
//         await set(ref(database, `users/${employeeKey}/syncMetadata`), {
//           isEmployee: true,
//           adminEmail: adminEmail,
//           lastFullSyncAt: new Date().toISOString(),
//           syncedPaths: SYNC_PATHS,
//           syncStatus: 'active',
//           autoSyncEnabled: true,
//           excludedPaths: ['employees', 'branches']
//         });
//         for (const path of SYNC_PATHS) {
//           if (adminData[path]) {
//             const pathRef = ref(database, `users/${employeeKey}/${path}`);
//             await set(pathRef, adminData[path]);
//             console.log(`✅ Copied ${path} to employee`);
//           }
//         }
//         console.log(`✅ Selective data copy completed (employee and branch management data excluded)`);
//         return true;
//       } else {
//         throw new Error('No admin data found to copy');
//       }
//     } catch (error) {
//       console.error('❌ Error copying data to employee:', error);
//       throw error;
//     } finally {
//       setIsSyncing(false);
//     }
//   }, [name, email, address, phone, bloodGroup, dob, userRole, active, loginType, assignLocation, flatDiscount, dayEndDenomination, currentUser]);

//   // Handle add employee
//   const handleAddEmployee = async (e) => {
//     e.preventDefault();
//     setMessage('');
//     setMessageType('');
//     if (password !== retypePassword) {
//       setMessage("Passwords don't match!");
//       setMessageType('error');
//       return;
//     }
//     const adminPassword = prompt("Please enter your admin password to create employee account:");
//     if (!adminPassword) {
//       setMessage("Password confirmation required to create employee account.");
//       setMessageType('error');
//       return;
//     }
//     if (name && email && address && phone && userRole && password && currentUser) {
//       try {
//         const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//         if (!hasAccess) {
//           setMessage('Access denied: You do not have permission to manage employees.');
//           setMessageType('error');
//           return;
//         }
//         setIsSyncing(true);
//         try {
//           await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
//         } catch (error) {
//           throw new Error('Invalid admin password. Please try again.');
//         }
//         const adminEmail = currentUser.email;
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         await signOut(auth);
//         await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
//         const adminEmailKey = adminEmail.replace(/\./g, '_');
//         const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
//         const employeeData = {
//           active,
//           name,
//           email,
//           address,
//           phone,
//           bloodGroup,
//           dob,
//           userRole,
//           loginType,
//           assignLocation,
//           flatDiscount,
//           dayEndDenomination,
//           createdAt: new Date().toISOString(),
//           createdBy: adminEmail,
//           adminEmail: adminEmail,
//           firebaseUid: userCredential.user.uid,
//           syncStatus: 'pending',
//           autoSyncEnabled: true
//         };
//         const newEmployeeRef = await push(employeesRef, employeeData);
//         await copyAllDataToEmployee(adminEmail, email);
//         const empUpdateRef = ref(database, `users/${adminEmailKey}/employees/${newEmployeeRef.key}`);
//         await update(empUpdateRef, {
//           syncStatus: 'synced',
//           lastSyncAt: new Date().toISOString(),
//           globalSyncActive: true
//         });
//         setTimeout(() => {
//           globalSyncService.refreshSync();
//         }, 1000);
//         setTimeout(() => {
//           globalSyncService.ensureSyncActive();
//         }, 3000);
//         setTimeout(() => {
//           globalSyncService.initializeGlobalSync();
//         }, 5000);
//         handleResetForm();
//         setShowEmployeeForm(false);
//         setMessage(`Employee "${name}" added successfully! Real-time bidirectional sync is active.`);
//         setMessageType('success');
//       } catch (error) {
//         console.error("❌ Error adding employee: ", error);
//         setMessage(`Failed to add employee: ${error.message}`);
//         setMessageType('error');
//       } finally {
//         setIsSyncing(false);
//       }
//     } else {
//       setMessage("Please fill in all required fields!");
//       setMessageType('error');
//     }
//   };

// const handleAddBranch = async (e) => {
//   e.preventDefault();
//   setMessage('');
//   setMessageType('');
  
//   if (branchUserPassword !== branchUserRetypePassword) {
//     setMessage("Branch user passwords don't match!");
//     setMessageType('error');
//     return;
//   }
  
//   const adminPassword = prompt("Please enter your admin password to create branch account:");
//   if (!adminPassword) {
//     setMessage("Password confirmation required to create branch account.");
//     setMessageType('error');
//     return;
//   }
  
//   if (branchName && branchAddress && branchUserEmail && branchUserPassword && currentUser) {
//     try {
//       const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
//       if (!hasAccess) {
//         setMessage('Access denied: You do not have permission to manage branches.');
//         setMessageType('error');
//         return;
//       }
      
//       setIsSyncing(true);
      
//       try {
//         await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
//       } catch (error) {
//         throw new Error('Invalid admin password. Please try again.');
//       }
      
//       const adminEmail = currentUser.email;
//       const userCredential = await createUserWithEmailAndPassword(auth, branchUserEmail, branchUserPassword);
      
//       await signOut(auth);
//       await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
      
//       const adminEmailKey = adminEmail.replace(/\./g, '_');
//       const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
      
//       const newBranchData = {
//         name: branchName,
//         address: branchAddress,
//         phone: branchPhone,
//         email: branchEmail,
//         manager: branchManager,
//         userEmail: branchUserEmail,
//         firebaseUid: userCredential.user.uid,
//         createdAt: new Date().toISOString(),
//         createdBy: adminEmail,
//         active: true,
//         autoSyncEnabled: false
//       };
      
//       const newBranchRef = await push(branchesRef, newBranchData);
      
//       const branchKey = branchUserEmail.replace(/\./g, '_');
      
//       // Set branch profile (similar to employee profile structure)
//       const branchProfile = {
//         role: 'branch',
//         isBranch: true,
//         adminEmail: adminEmail,
//         adminEmailKey: adminEmailKey,
//         canAccessAdminData: true,
//         inheritedFrom: adminEmail,
//         branchInfo: {
//           name: branchName,
//           address: branchAddress,
//           phone: branchPhone,
//           email: branchEmail,
//           manager: branchManager,
//           userEmail: branchUserEmail
//         },
//         createdAt: new Date().toISOString(),
//         lastSyncWith: adminEmailKey
//       };
//       await set(ref(database, `users/${branchKey}/profile`), branchProfile);
      
//       // Set sync metadata for branch
//       await set(ref(database, `users/${branchKey}/syncMetadata`), {
//         isBranch: true,
//         adminEmail: adminEmail,
//         lastFullSyncAt: new Date().toISOString(),
//         syncedPaths: SYNC_PATHS,
//         syncStatus: 'active',
//         autoSyncEnabled: false, // Branch doesn't use auto-sync
//         excludedPaths: ['employees', 'branches']
//       });
      
//       // Copy all business data to branch
//       const adminDataRef = ref(database, `users/${adminEmailKey}`);
//       const adminSnapshot = await new Promise((resolve, reject) => {
//         onValue(adminDataRef, resolve, { onlyOnce: true });
//         setTimeout(() => reject(new Error('Timeout fetching admin data')), 10000);
//       });
      
//       const adminData = adminSnapshot.val();
//       if (adminData) {
//         // Copy each business data path to branch
//         for (const path of SYNC_PATHS) {
//           if (adminData[path]) {
//             const pathRef = ref(database, `users/${branchKey}/${path}`);
//             await set(pathRef, adminData[path]);
//             console.log(`✅ Copied ${path} to branch`);
//           }
//         }
//       }
      
//       // Update the branch record in admin's branches list with sync status
//       const branchUpdateRef = ref(database, `users/${adminEmailKey}/branches/${newBranchRef.key}`);
//       await update(branchUpdateRef, {
//         syncStatus: 'synced',
//         lastSyncAt: new Date().toISOString(),
//         dataStructure: 'hierarchical'
//       });
      
//       // Reset form
//       setBranchName('');
//       setBranchAddress('');
//       setBranchPhone('');
//       setBranchEmail('');
//       setBranchManager('');
//       setBranchUserEmail('');
//       setBranchUserPassword('');
//       setBranchUserRetypePassword('');
//       setShowBranchForm(false);
      
//       setMessage('Branch created successfully! All business data has been copied to the branch account.');
//       setMessageType('success');
      
//     } catch (error) {
//       console.error("❌ Error adding branch: ", error);
//       setMessage(`Failed to add branch: ${error.message}`);
//       setMessageType('error');
//     } finally {
//       setIsSyncing(false);
//     }
//   } else {
//     setMessage("Please fill in all required fields including user credentials!");
//     setMessageType('error');
//   }
// };

//   // Load employees, branches, and roles
//   useEffect(() => {
//     if (currentUser) {
//       console.log('📋 ManageEmployeeRole loaded - ensuring global sync is active...');
//       setTimeout(() => {
//         globalSyncService.ensureSyncActive();
//       }, 500);
//       const adminEmailKey = currentUser.email.replace(/\./g, '_');
//       checkEmployeeAccess(currentUser.email, 'employees').then(hasAccess => {
//         if (hasAccess) {
//           const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
//           const unsubscribeEmployees = onValue(employeesRef, (snapshot) => {
//             const data = snapshot.val();
//             const employeesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
//             setEmployees(employeesList);
//           }, {
//             errorCallback: (error) => {
//               console.error('Error loading employees:', error);
//               setMessage('Failed to load employees: ' + error.message);
//               setMessageType('error');
//             }
//           });
//           return () => unsubscribeEmployees();
//         }
//       });
//       const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
//       const unsubscribeBranches = onValue(branchesRef, (snapshot) => {
//         const data = snapshot.val();
//         const branchesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
//         setBranches(branchesList);
//       }, {
//         errorCallback: (error) => {
//           console.error('Error loading branches:', error);
//           setMessage('Failed to load branches: ' + error.message);
//           setMessageType('error');
//         }
//       });
//       const rolesRef = ref(database, `users/${adminEmailKey}/roles`);
//       const unsubscribeRoles = onValue(rolesRef, (snapshot) => {
//         const data = snapshot.val();
//         const rolesList = data ? Object.values(data).map(role => role.roleName) : [];
//         setRoles(rolesList);
//       }, {
//         errorCallback: (error) => {
//           console.error('Error loading roles:', error);
//           setMessage('Failed to load roles: ' + error.message);
//           setMessageType('error');
//         }
//       });
//       return () => {
//         unsubscribeBranches();
//         unsubscribeRoles();
//       };
//     }
//   }, [currentUser, checkEmployeeAccess]);

//   const handleResetForm = () => {
//     setActive(true);
//     setName('');
//     setEmail('');
//     setAddress('');
//     setPhone('');
//     setBloodGroup('');
//     setDob('');
//     setUserRole('');
//     setLoginType('Main Login');
//     setAssignLocation('');
//     setFlatDiscount(false);
//     setDayEndDenomination(false);
//     setPassword('');
//     setRetypePassword('');
//   };

//   const handleEmployeeClick = async (employee) => {
//     const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//     if (hasAccess) {
//       setSelectedEmployee(employee);
//       setShowEmployeeDetails(true);
//     } else {
//       setMessage('Access denied: You do not have permission to view employee details.');
//       setMessageType('error');
//     }
//   };

//   const handleCancel = () => {
//     handleResetForm();
//     setShowEmployeeForm(false);
//     setShowBranchForm(false);
//     setMessage('');
//     setMessageType('');
//   };

//   // Styles matching CustomerForm
//   const styles = {
//     container: {
//       maxWidth: '1200px',
//       margin: '2rem auto',
//       padding: '2rem',
//       backgroundColor: '#ffffff',
//       borderRadius: '16px',
//       boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
//       minHeight: '100vh',
//     },
//     formWrapper: {
//       backgroundColor: '#ffffff',
//       borderRadius: '20px',
//       padding: '2.5rem',
//       border: '1px solid #e2e8f0',
//     },
//     heading: {
//       fontSize: '2rem',
//       fontWeight: '700',
//       marginBottom: '2rem',
//       color: '#1f2937',
//       textAlign: 'center',
//     },
//     messageSuccess: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#d1fae5',
//       color: '#065f46',
//       border: '1px solid #a7f3d0',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     messageError: {
//       padding: '1rem 1.5rem',
//       marginBottom: '1.5rem',
//       borderRadius: '12px',
//       backgroundColor: '#fee2e2',
//       color: '#b91c1c',
//       border: '1px solid #fecaca',
//       fontSize: '0.9rem',
//       fontWeight: '500',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     loadingContainer: {
//       textAlign: 'center',
//       padding: '4rem 2rem',
//       color: '#6b7280',
//     },
//     loadingSpinner: {
//       width: '3rem',
//       height: '3rem',
//       border: '4px solid #e5e7eb',
//       borderTop: '4px solid #2563eb',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//       margin: '0 auto 1rem',
//     },
//     formLayout: {
//       display: 'grid',
//       gridTemplateColumns: '1fr',
//       gap: '2rem',
//     },
//     twoColumnLayout: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
//       gap: '2rem',
//     },
//     section: {
//       backgroundColor: '#fff',
//       padding: '1.5rem',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//       boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
//     },
//     sectionHeading: {
//       fontSize: '1.25rem',
//       fontWeight: '600',
//       marginBottom: '1rem',
//       color: '#1f2937',
//     },
//     inputGroup: {
//       marginBottom: '1rem',
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '0.5rem',
//     },
//     label: {
//       display: 'block',
//       fontSize: '0.875rem',
//       fontWeight: '500',
//       color: '#374151',
//       marginBottom: '0.25rem',
//     },
//     requiredAsterisk: {
//       color: '#ef4444',
//       marginLeft: '0.25rem',
//     },
//     input: {
//       display: 'block',
//       width: '90%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       transition: 'border-color 0.2s ease',
//     },
//     select: {
//       display: 'block',
//       width: '100%',
//       padding: '0.5rem 0.75rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '6px',
//       fontSize: '0.875rem',
//       backgroundColor: '#fff',
//       cursor: 'pointer',
//       appearance: 'none',
//       backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
//       backgroundPosition: 'right 0.5rem center',
//       backgroundRepeat: 'no-repeat',
//       backgroundSize: '1em 1em',
//       paddingRight: '2rem',
//     },
//     checkboxContainer: {
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     checkbox: {
//       width: '1rem',
//       height: '1rem',
//       border: '1px solid #d1d5db',
//       borderRadius: '4px',
//       cursor: 'pointer',
//     },
//     buttonContainer: {
//       marginTop: '2rem',
//       display: 'flex',
//       justifyContent: 'flex-end',
//       gap: '1rem',
//       paddingTop: '1rem',
//       borderTop: '1px solid #e2e8f0',
//     },
//     button: {
//       padding: '0.5rem 1.5rem',
//       borderRadius: '6px',
//       fontWeight: '500',
//       fontSize: '0.875rem',
//       cursor: 'pointer',
//       border: 'none',
//       transition: 'all 0.2s ease',
//     },
//     submitButton: {
//       backgroundColor: '#10b981',
//       color: 'white',
//     },
//     cancelButton: {
//       backgroundColor: '#ef4444',
//       color: 'white',
//     },
//     gridTwoColumns: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
//       gap: '1rem',
//     },
//     header: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       alignItems: 'center',
//       marginBottom: '1.5rem',
//       flexWrap: 'wrap',
//       gap: '1rem',
//     },
//     headerTitle: {
//       fontSize: '1.5rem',
//       fontWeight: '700',
//       color: '#2563eb',
//     },
//     headerButtons: {
//       display: 'flex',
//       gap: '0.5rem',
//       flexWrap: 'wrap',
//       alignItems: 'center',
//     },
//     addButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '500',
//       cursor: isSyncing ? 'not-allowed' : 'pointer',
//       border: 'none',
//       fontSize: '0.875rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
//     },
//     branchButton: {
//       padding: '0.5rem 1.25rem',
//       borderRadius: '6px',
//       backgroundColor: '#10b981',
//       color: 'white',
//       fontWeight: '500',
//       cursor: isSyncing ? 'not-allowed' : 'pointer',
//       border: 'none',
//       fontSize: '0.875rem',
//       transition: 'all 0.2s ease',
//       boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
//     },
//     tableContainer: {
//       marginTop: '1rem',
//       overflowX: 'auto',
//       backgroundColor: 'white',
//       borderRadius: '8px',
//       border: '1px solid #e2e8f0',
//     },
//     table: {
//       width: '100%',
//       borderCollapse: 'collapse',
//       fontSize: '0.875rem',
//     },
//     tableHeader: {
//       padding: '0.75rem',
//       textAlign: 'center',
//       backgroundColor: '#2563eb',
//       color: 'white',
//       fontWeight: '600',
//       fontSize: '0.875rem',
//       textTransform: 'uppercase',
//       border: '1px solid #1e40af',
//     },
//     tableCell: {
//       padding: '0.75rem',
//       border: '1px solid #d1d5db',
//       color: '#374151',
//       textAlign: 'center',
//       cursor: 'pointer',
//     },
//     branchCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '0.5rem 0',
//     },
//     branchName: {
//       fontSize: '1rem',
//       fontWeight: '600',
//       color: '#1f2937',
//       marginBottom: '0.5rem',
//     },
//     branchInfo: {
//       fontSize: '0.875rem',
//       color: '#6b7280',
//       marginBottom: '0.25rem',
//     },
//     employeeDetailCard: {
//       backgroundColor: '#f8fafc',
//       border: '1px solid #e2e8f0',
//       borderRadius: '8px',
//       padding: '1.5rem',
//       margin: '1rem 0',
//     },
//     detailRow: {
//       display: 'flex',
//       justifyContent: 'space-between',
//       padding: '0.5rem 0',
//       borderBottom: '1px solid #e2e8f0',
//     },
//     detailLabel: {
//       fontWeight: '600',
//       color: '#374151',
//     },
//     detailValue: {
//       color: '#6b7280',
//     },
//     infoCard: {
//       backgroundColor: '#dbeafe',
//       border: '1px solid #93c5fd',
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '1rem 0',
//       color: '#1e40af',
//     },
//     syncStatusCard: {
//       backgroundColor: isSyncing ? '#fef3c7' : '#dcfce7',
//       border: `1px solid ${isSyncing ? '#fbbf24' : '#86efac'}`,
//       borderRadius: '8px',
//       padding: '1rem',
//       margin: '1rem 0',
//       color: isSyncing ? '#d97706' : '#15803d',
//       display: 'flex',
//       alignItems: 'center',
//       gap: '0.5rem',
//     },
//     spinner: {
//       width: '1rem',
//       height: '1rem',
//       border: '2px solid transparent',
//       borderTop: '2px solid currentColor',
//       borderRadius: '50%',
//       animation: 'spin 1s linear infinite',
//     },
//   };

//   if (!currentUser) {
//     return (
//       <div style={styles.container}>
//         <div style={styles.formWrapper}>
//           <div style={styles.loadingContainer}>
//             <p>Please log in to access employee management.</p>
//           </div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div style={styles.container}>
//       <style jsx>{`
//         @keyframes spin {
//           0% { transform: rotate(0deg); }
//           100% { transform: rotate(360deg); }
//         }
//         @media (max-width: 768px) {
//           .twoColumnLayout {
//             grid-template-columns: 1fr;
//           }
//           .gridTwoColumns {
//             grid-template-columns: 1fr;
//           }
//           .buttonContainer {
//             flex-direction: column;
//           }
//           .button {
//             width: 100%;
//             justify-content: center;
//           }
//         }
//         input:focus,
//         select:focus {
//           outline: none;
//           border-color: #2563eb;
//           box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
//         }
//         input:hover,
//         select:hover {
//           border-color: #a1a1aa;
//         }
//         button:hover:not(:disabled) {
//           filter: brightness(90%);
//         }
//       `}</style>
//       <div style={styles.formWrapper}>
//         {showEmployeeForm ? (
//           <>
//             <h1 style={styles.heading}>👤 Add New Employee</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {isSyncing ? (
//               <div style={styles.loadingContainer}>
//                 <div style={styles.loadingSpinner}></div>
//                 <p>Creating employee and syncing data...</p>
//               </div>
//             ) : (
//               <form onSubmit={handleAddEmployee}>
//                 <div style={styles.formLayout}>
//                   <div style={styles.twoColumnLayout}>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>📋 Personal Details</h2>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={active}
//                             onChange={(e) => setActive(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Active</label>
//                         </div>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={name}
//                           onChange={(e) => setName(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter name"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Email<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="email"
//                           value={email}
//                           onChange={(e) => setEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter email"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Address<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={address}
//                           onChange={(e) => setAddress(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter address"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Phone No.<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={phone}
//                           onChange={(e) => setPhone(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter phone number"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Blood Group</label>
//                         <input
//                           type="text"
//                           value={bloodGroup}
//                           onChange={(e) => setBloodGroup(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter blood group"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Date of Birth</label>
//                         <input
//                           type="date"
//                           value={dob}
//                           onChange={(e) => setDob(e.target.value)}
//                           style={styles.input}
//                         />
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔑 Login Details</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Role Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <select
//                           value={userRole}
//                           onChange={(e) => setUserRole(e.target.value)}
//                           style={styles.select}
//                           required
//                         >
//                           <option value="">Select Role</option>
//                           {roles.map((role) => (
//                             <option key={role} value={role}>
//                               {role}
//                             </option>
//                           ))}
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Login Type</label>
//                         <select
//                           value={loginType}
//                           onChange={(e) => setLoginType(e.target.value)}
//                           style={styles.select}
//                         >
//                           <option value="Main Login">Main Login</option>
//                           <option value="Sub Login">Sub Login</option>
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Assign Location</label>
//                         <select
//                           value={assignLocation}
//                           onChange={(e) => setAssignLocation(e.target.value)}
//                           style={styles.select}
//                         >
//                           <option value="">Select Location</option>
//                           {branches.map((branch) => (
//                             <option key={branch.id} value={branch.name}>
//                               {branch.name}
//                             </option>
//                           ))}
//                           <option value="WAREHOUSE/Warehouse/Puduche">WAREHOUSE/Warehouse/Puduche</option>
//                           <option value="STORE/Store/CITY">STORE/Store/CITY</option>
//                         </select>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={flatDiscount}
//                             onChange={(e) => setFlatDiscount(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Flat Discount</label>
//                         </div>
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <div style={styles.checkboxContainer}>
//                           <input
//                             type="checkbox"
//                             checked={dayEndDenomination}
//                             onChange={(e) => setDayEndDenomination(e.target.checked)}
//                             style={styles.checkbox}
//                           />
//                           <label style={styles.label}>Day End Denomination</label>
//                         </div>
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔒 Credentials</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={password}
//                           onChange={(e) => setPassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter password"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Retype Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={retypePassword}
//                           onChange={(e) => setRetypePassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Retype password"
//                           required
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={styles.buttonContainer}>
//                   <button
//                     type="button"
//                     onClick={handleCancel}
//                     style={{ ...styles.button, ...styles.cancelButton }}
//                     disabled={isSyncing}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     style={{ ...styles.button, ...styles.submitButton }}
//                     disabled={isSyncing}
//                   >
//                     Add Employee
//                   </button>
//                 </div>
//               </form>
//             )}
//           </>
//         ) : showBranchForm ? (
//           <>
//             <h1 style={styles.heading}>🏢 Add New Branch</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {isSyncing ? (
//               <div style={styles.loadingContainer}>
//                 <div style={styles.loadingSpinner}></div>
//                 <p>Creating branch and syncing data...</p>
//               </div>
//             ) : (
//               <form onSubmit={handleAddBranch}>
//                 <div style={styles.formLayout}>
//                   <div style={styles.twoColumnLayout}>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🏢 Branch Details</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Branch Name<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={branchName}
//                           onChange={(e) => setBranchName(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter branch name"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Address<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="text"
//                           value={branchAddress}
//                           onChange={(e) => setBranchAddress(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter address"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Phone</label>
//                         <input
//                           type="text"
//                           value={branchPhone}
//                           onChange={(e) => setBranchPhone(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter phone number"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Email</label>
//                         <input
//                           type="email"
//                           value={branchEmail}
//                           onChange={(e) => setBranchEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter email"
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>Manager</label>
//                         <input
//                           type="text"
//                           value={branchManager}
//                           onChange={(e) => setBranchManager(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter manager name"
//                         />
//                       </div>
//                     </div>
//                     <div style={styles.section}>
//                       <h2 style={styles.sectionHeading}>🔒 Branch User Credentials</h2>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           User Email<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="email"
//                           value={branchUserEmail}
//                           onChange={(e) => setBranchUserEmail(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter user email for branch login"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           User Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={branchUserPassword}
//                           onChange={(e) => setBranchUserPassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Enter user password"
//                           required
//                         />
//                       </div>
//                       <div style={styles.inputGroup}>
//                         <label style={styles.label}>
//                           Retype User Password<span style={styles.requiredAsterisk}>*</span>
//                         </label>
//                         <input
//                           type="password"
//                           value={branchUserRetypePassword}
//                           onChange={(e) => setBranchUserRetypePassword(e.target.value)}
//                           style={styles.input}
//                           placeholder="Retype user password"
//                           required
//                         />
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//                 <div style={styles.buttonContainer}>
//                   <button
//                     type="button"
//                     onClick={handleCancel}
//                     style={{ ...styles.button, ...styles.cancelButton }}
//                     disabled={isSyncing}
//                   >
//                     Cancel
//                   </button>
//                   <button
//                     type="submit"
//                     style={{ ...styles.button, ...styles.submitButton }}
//                     disabled={isSyncing}
//                   >
//                     Add Branch
//                   </button>
//                 </div>
//               </form>
//             )}
//           </>
//         ) : showEmployeeDetails && selectedEmployee ? (
//           <>
//             <h1 style={styles.heading}>👤 Employee Details - {selectedEmployee.name}</h1>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             <div style={styles.formLayout}>
//               <div style={styles.twoColumnLayout}>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>👤 Personal Information</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Name</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.name}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Email</label>
//                     <input
//                       type="email"
//                       value={selectedEmployee.email}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Phone</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.phone}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Address</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.address}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Blood Group</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.bloodGroup || 'Not specified'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Date of Birth</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.dob || 'Not specified'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>💼 Work Information</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Role</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.userRole}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Login Type</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.loginType}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Assigned Location</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.assignLocation || 'Not assigned'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Status</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.active ? 'Active' : 'Inactive'}
//                       style={{ ...styles.input, color: selectedEmployee.active ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Admin Email</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.adminEmail}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Sync Status</label>
//                     <input
//                       type="text"
//                       value={
//                         selectedEmployee.syncStatus === 'synced'
//                           ? 'Real-time Sync Active'
//                           : selectedEmployee.syncStatus === 'pending'
//                           ? 'Sync Pending'
//                           : 'Bidirectional Sync'
//                       }
//                       style={{
//                         ...styles.input,
//                         color:
//                           selectedEmployee.syncStatus === 'synced'
//                             ? '#10b981'
//                             : selectedEmployee.syncStatus === 'pending'
//                             ? '#f59e0b'
//                             : '#2563eb'
//                       }}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//                 <div style={styles.section}>
//                   <h2 style={styles.sectionHeading}>⚙️ Permissions & Settings</h2>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Flat Discount</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.flatDiscount ? 'Enabled' : 'Disabled'}
//                       style={{ ...styles.input, color: selectedEmployee.flatDiscount ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Day End Denomination</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.dayEndDenomination ? 'Enabled' : 'Disabled'}
//                       style={{ ...styles.input, color: selectedEmployee.dayEndDenomination ? '#10b981' : '#ef4444' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Data Access Level</label>
//                     <input
//                       type="text"
//                       value="Full Business Data (Excluding Employee & Branch Management)"
//                       style={{ ...styles.input, color: '#10b981' }}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Created Date</label>
//                     <input
//                       type="text"
//                       value={
//                         selectedEmployee.createdAt
//                           ? new Date(selectedEmployee.createdAt).toLocaleDateString('en-US', {
//                               year: 'numeric',
//                               month: 'long',
//                               day: 'numeric',
//                               hour: '2-digit',
//                               minute: '2-digit'
//                             })
//                           : 'Not available'
//                       }
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Firebase UID</label>
//                     <input
//                       type="text"
//                       value={selectedEmployee.firebaseUid ? selectedEmployee.firebaseUid.substring(0, 8) + '...' : 'Not available'}
//                       style={styles.input}
//                       readOnly
//                     />
//                   </div>
//                   <div style={styles.inputGroup}>
//                     <label style={styles.label}>Sync Type</label>
//                     <input
//                       type="text"
//                       value="Bidirectional Real-time (Business Data Only)"
//                       style={{ ...styles.input, color: '#8b5cf6' }}
//                       readOnly
//                     />
//                   </div>
//                 </div>
//               </div>
//               <div style={styles.section}>
//                 <h2 style={styles.sectionHeading}>📊 Real-time Data Access & Sync Status</h2>
//                 <div style={{ marginBottom: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
//                   All business data changes are automatically synchronized in real-time between admin and employee accounts (excluding employee and branch management data).
//                 </div>
//                 <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
//                   {SYNC_PATHS.map((path, index) => (
//                     <div
//                       key={path}
//                       style={{
//                         backgroundColor: ['#dbeafe', '#dcfce7', '#fef3c7', '#fce7f3', '#f3e8ff', '#ecfdf5', '#fef2f2', '#f0fdfa'][index % 8],
//                         padding: '1rem',
//                         borderRadius: '8px',
//                         textAlign: 'center'
//                       }}
//                     >
//                       <div style={{ fontSize: '1.5rem', fontWeight: '700', color: ['#2563eb', '#16a34a', '#d97706', '#be185d', '#7c3aed', '#059669', '#dc2626', '#0d9488'][index % 8] }}>🔄</div>
//                       <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '600' }}>{path.charAt(0).toUpperCase() + path.slice(1)}</div>
//                       <div style={{ fontSize: '0.75rem', color: '#10b981', marginTop: '0.25rem' }}>Real-time Sync</div>
//                     </div>
//                   ))}
//                 </div>
//                 <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
//                   <h4 style={{ margin: '0 0 0.75rem 0', fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>
//                     🔄 Bidirectional Sync Flow
//                   </h4>
//                   <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
//                     <div style={{ padding: '0.5rem 1rem', backgroundColor: '#2563eb', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
//                       {selectedEmployee.adminEmail}
//                     </div>
//                     <div style={{ fontSize: '1.2rem' }}>↔️</div>
//                     <div style={{ padding: '0.5rem 1rem', backgroundColor: '#10b981', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
//                       {selectedEmployee.email}
//                     </div>
//                   </div>
//                   <div style={{ textAlign: 'center', fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
//                     Real-time bidirectional data synchronization active (business data only)
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div style={styles.buttonContainer}>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#2563eb', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (hasAccess) {
//                     setMessage('Edit functionality will be implemented');
//                     setMessageType('info');
//                     setShowEmployeeDetails(false);
//                   } else {
//                     setMessage('Access denied: You do not have permission to edit employees.');
//                     setMessageType('error');
//                   }
//                 }}
//               >
//                 ✏️ Edit Employee
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: selectedEmployee.active ? '#ef4444' : '#10b981', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (!hasAccess) {
//                     setMessage('Access denied: You do not have permission to modify employee status.');
//                     setMessageType('error');
//                     return;
//                   }
//                   const action = selectedEmployee.active ? 'deactivate' : 'activate';
//                   if (window.confirm(`Are you sure you want to ${action} this employee? This will affect their data sync status.`)) {
//                     setMessage(`${action.charAt(0).toUpperCase() + action.slice(1)} functionality will be implemented`);
//                     setMessageType('info');
//                   }
//                 }}
//               >
//                 {selectedEmployee.active ? '🚫 Deactivate' : '✅ Activate'}
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#f59e0b', color: 'white' }}
//                 onClick={async () => {
//                   const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                   if (!hasAccess) {
//                     setMessage('Access denied: You do not have permission to reset employee passwords.');
//                     setMessageType('error');
//                     return;
//                   }
//                   if (window.confirm('Reset password for this employee? They will need to use the new password to login. Data sync will remain active.')) {
//                     setMessage('Reset password functionality will be implemented');
//                     setMessageType('info');
//                   }
//                 }}
//               >
//                 🔑 Reset Password
//               </button>
//               <button
//                 style={{ ...styles.button, backgroundColor: '#6b7280', color: 'white' }}
//                 onClick={() => setShowEmployeeDetails(false)}
//               >
//                 ❌ Close
//               </button>
//             </div>
//           </>
//         ) : (
//           <>
//             <div style={styles.header}>
//               <div style={styles.headerTitle}>
//                 Manage Employee Role & Branches
//                 <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '400' }}>
//                   Logged in as: {currentUser.email}
//                 </div>
//               </div>
//               <div style={styles.headerButtons}>
//                 <button
//                   style={styles.addButton}
//                   onClick={async () => {
//                     const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
//                     if (hasAccess && !isSyncing) setShowEmployeeForm(true);
//                     else if (!hasAccess) {
//                       setMessage('Access denied: You do not have permission to add employees.');
//                       setMessageType('error');
//                     }
//                   }}
//                   disabled={isSyncing}
//                 >
//                   + Add Employee
//                 </button>
//                 <button
//                   style={styles.branchButton}
//                   onClick={async () => {
//                     const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
//                     if (hasAccess && !isSyncing) setShowBranchForm(true);
//                     else if (!hasAccess) {
//                       setMessage('Access denied: You do not have permission to add branches.');
//                       setMessageType('error');
//                     }
//                   }}
//                   disabled={isSyncing}
//                 >
//                   + Add Branch
//                 </button>
//               </div>
//             </div>
//             {message && (
//               <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
//                 <span>{messageType === 'success' ? '✅' : '❌'}</span>
//                 {message}
//               </div>
//             )}
//             {/* <div style={styles.syncStatusCard}>
//               <div style={styles.spinner}></div>
//               <div>
//                 <strong>{isSyncing ? 'Auto-Sync In Progress...' : 'Global Real-time Bidirectional Sync Active'}</strong>
//                 <div style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
//                   {isSyncing
//                     ? 'Please wait while data is being synchronized automatically.'
//                     : 'All data changes are automatically synced globally in real-time across the entire application.'}
//                 </div>
//               </div>
//             </div> */}
//             {/* <div style={styles.infoCard}>
//               <h3 style={{ margin: '0 0 0.5rem 0', fontSize: '1rem', fontWeight: '600' }}>
//                 📋 Global Automatic Data Synchronization System
//               </h3>
//               <p style={{ margin: '0', fontSize: '0.875rem', lineHeight: '1.4' }}>
//                 <strong>🚀 Global Automatic Features:</strong><br/>
//                 • <strong>Always Active:</strong> Sync works automatically across the entire app, not just this page<br/>
//                 • <strong>New Employees:</strong> Automatically receive ALL business data instantly upon creation<br/>
//                 • <strong>Real-time Sync:</strong> All business changes sync instantly across all users<br/>
//                 • <strong>Bidirectional:</strong> Data flows seamlessly between admin and all employee accounts<br/>
//                 • <strong>Background Operation:</strong> Works automatically without any user intervention<br/>
//                 • <strong>Business Data Auto-Synced:</strong> {SYNC_PATHS.join(', ')}<br/>
//                 • <strong>Admin-Only Data:</strong> Employee management, branch management, user roles, authentication settings
//               </p>
//             </div> */}
//             <div style={styles.section}>
//               <h2 style={styles.sectionHeading}>🏢 Branches ({branches.length})</h2>
//               {branches.length === 0 ? (
//                 <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//                   No branches added yet. Click "Add Branch" to create your first branch.
//                 </p>
//               ) : (
//                 <div style={styles.gridTwoColumns}>
//                   {branches.map((branch) => (
//                     <div key={branch.id} style={styles.branchCard}>
//                       <div style={styles.branchName}>{branch.name}</div>
//                       <div style={styles.branchInfo}>📍 {branch.address}</div>
//                       {branch.phone && <div style={styles.branchInfo}>📞 {branch.phone}</div>}
//                       {branch.email && <div style={styles.branchInfo}>📧 {branch.email}</div>}
//                       {branch.manager && <div style={styles.branchInfo}>👤 Manager: {branch.manager}</div>}
//                       <div style={{ fontSize: '0.75rem', color: '#10b981', fontWeight: '600', marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                     
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               )}
//             </div>
//             <div style={styles.section}>
//               <h2 style={styles.sectionHeading}>📋 Employee List ({employees.length})</h2>
//               {employees.length === 0 ? (
//                 <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
//                   No employees added yet. Click "Add Employee" to add your first employee.
//                 </p>
//               ) : (
//                 <div style={styles.tableContainer}>
//                   <table style={styles.table}>
//                     <thead>
//                       <tr>
//                         <th style={styles.tableHeader}>ID</th>
//                         <th style={styles.tableHeader}>USER NAME</th>
//                         <th style={styles.tableHeader}>ROLE</th>
//                         <th style={styles.tableHeader}>EMAIL</th>
//                         <th style={styles.tableHeader}>ADMIN EMAIL</th>
//                         <th style={styles.tableHeader}>ASSIGNED LOCATION</th>
//                         <th style={styles.tableHeader}>SYNC STATUS</th>
//                         <th style={styles.tableHeader}>STATUS</th>
//                         <th style={styles.tableHeader}>ACTION</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {employees.map((employee, index) => (
//                         <tr
//                           key={employee.id}
//                           style={{ backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white' }}
//                           onClick={() => handleEmployeeClick(employee)}
//                         >
//                           <td style={styles.tableCell}>{index + 1}</td>
//                           <td style={styles.tableCell}>{employee.name}</td>
//                           <td style={styles.tableCell}>{employee.userRole}</td>
//                           <td style={styles.tableCell}>{employee.email}</td>
//                           <td style={styles.tableCell}>{employee.adminEmail}</td>
//                           <td style={styles.tableCell}>{employee.assignLocation || 'Not assigned'}</td>
//                           <td style={styles.tableCell}>
//                             <span style={{
//                               color: employee.syncStatus === 'synced' ? '#10b981' : employee.syncStatus === 'pending' ? '#f59e0b' : '#6b7280',
//                               fontWeight: '600'
//                             }}>
//                               {employee.syncStatus === 'synced' ? '✅ Synced' : employee.syncStatus === 'pending' ? '⏳ Pending' : '🔄 Active'}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{ color: employee.active ? '#10b981' : '#ef4444', fontWeight: '600' }}>
//                               {employee.active ? 'Active' : 'Inactive'}
//                             </span>
//                           </td>
//                           <td style={styles.tableCell}>
//                             <span style={{ color: '#f44336', cursor: 'pointer' }}>✏️</span>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//               )}
//             </div>
//           </>
//         )}
//       </div>
//     </div>
//   );
// };

// export default ManageEmployeeRole;

import React, { useState, useEffect, useCallback } from 'react';
import { database, ref, onValue, push, set, update, auth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut } from '../firebase';
import globalSyncService from '../Services/GlobalSyncService';

const ManageEmployeeRole = () => {
  const [currentUser, setCurrentUser] = useState(null);
  const [active, setActive] = useState(true);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [bloodGroup, setBloodGroup] = useState('');
  const [dob, setDob] = useState('');
  const [userRole, setUserRole] = useState('');
  const [loginType, setLoginType] = useState('Main Login');
  const [assignLocation, setAssignLocation] = useState('');
  const [flatDiscount, setFlatDiscount] = useState(false);
  const [dayEndDenomination, setDayEndDenomination] = useState(false);
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [employees, setEmployees] = useState([]);
  const [branches, setBranches] = useState([]);
  const [roles, setRoles] = useState([]);
  const [showEmployeeForm, setShowEmployeeForm] = useState(false);
  const [showBranchForm, setShowBranchForm] = useState(false);
  const [showEmployeeDetails, setShowEmployeeDetails] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [isSyncing, setIsSyncing] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  // Branch form states
  const [branchName, setBranchName] = useState('');
  const [branchAddress, setBranchAddress] = useState('');
  const [branchPhone, setBranchPhone] = useState('');
  const [branchEmail, setBranchEmail] = useState('');
  const [branchManager, setBranchManager] = useState('');
  const [branchUserEmail, setBranchUserEmail] = useState('');
  const [branchUserPassword, setBranchUserPassword] = useState('');
  const [branchUserRetypePassword, setBranchUserRetypePassword] = useState('');

  // Data structure paths that need to be synced
  const SYNC_PATHS = [
    'products',
    'categories',
    'brands',
    'customers',
    'invoices',
    'suppliers',
    'inventory',
    'reports',
    'settings',
    'companyInfo',
    'taxSettings',
    'paymentMethods',
    'discountSettings'
  ];

  // Blood group options
  const BLOOD_GROUPS = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];

  // Validation regex
  const nameRegex = /^[a-zA-Z\s'-]*$/; // Letters, spaces, hyphens, and apostrophes
  const phoneRegex = /^\d{0,10}$/; // Exactly 10 digits

  // Monitor authentication state
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setCurrentUser(user);
    });
    return () => unsubscribe();
  }, []);

  // Check employee access restrictions
  const checkEmployeeAccess = useCallback((currentUserEmail, requestedPath) => {
    const restrictedPaths = ['employees', 'branches'];
    return new Promise((resolve) => {
      const userKey = currentUserEmail.replace(/\./g, '_');
      const profileRef = ref(database, `users/${userKey}/profile`);
      onValue(profileRef, (snapshot) => {
        const profileData = snapshot.val();
        const isEmployee = profileData && profileData.isEmployee;
        if (isEmployee && restrictedPaths.includes(requestedPath)) {
          console.log(`🚫 Access denied: Employee ${currentUserEmail} cannot access ${requestedPath}`);
          resolve(false);
        } else {
          resolve(true);
        }
      }, { onlyOnce: true });
    });
  }, []);

  // Copy all data to employee (excluding employee and branch management data)
  const copyAllDataToEmployee = useCallback(async (adminEmail, employeeEmail) => {
    try {
      setIsSyncing(true);
      const adminKey = adminEmail.replace(/\./g, '_');
      const employeeKey = employeeEmail.replace(/\./g, '_');
      console.log(`🚀 Starting selective data copy from ${adminEmail} to ${employeeEmail} (excluding employee and branch management)...`);
      if (currentUser.email !== adminEmail) {
        console.log('🚫 Data sync denied: Only admin can sync data to new employees');
        return false;
      }
      const adminDataRef = ref(database, `users/${adminKey}`);
      const adminSnapshot = await new Promise((resolve, reject) => {
        onValue(adminDataRef, resolve, { onlyOnce: true });
        setTimeout(() => reject(new Error('Timeout fetching admin data')), 10000);
      });
      const adminData = adminSnapshot.val();
      if (adminData) {
        const employeeProfile = {
          role: 'employee',
          isEmployee: true,
          adminEmail: adminEmail,
          adminEmailKey: adminKey,
          canAccessAdminData: true,
          inheritedFrom: adminEmail,
          personalInfo: {
            name,
            email: employeeEmail,
            address,
            phone,
            bloodGroup,
            dob,
            userRole,
            active,
            loginType,
            assignLocation,
            flatDiscount,
            dayEndDenomination,
          },
          createdAt: new Date().toISOString(),
          lastSyncWith: adminKey
        };
        await set(ref(database, `users/${employeeKey}/profile`), employeeProfile);
        await set(ref(database, `users/${employeeKey}/syncMetadata`), {
          isEmployee: true,
          adminEmail: adminEmail,
          lastFullSyncAt: new Date().toISOString(),
          syncedPaths: SYNC_PATHS,
          syncStatus: 'active',
          autoSyncEnabled: true,
          excludedPaths: ['employees', 'branches']
        });
        for (const path of SYNC_PATHS) {
          if (adminData[path]) {
            const pathRef = ref(database, `users/${employeeKey}/${path}`);
            await set(pathRef, adminData[path]);
            console.log(`✅ Copied ${path} to employee`);
          }
        }
        console.log(`✅ Selective data copy completed (employee and branch management data excluded)`);
        return true;
      } else {
        throw new Error('No admin data found to copy');
      }
    } catch (error) {
      console.error('❌ Error copying data to employee:', error);
      throw error;
    } finally {
      setIsSyncing(false);
    }
  }, [name, email, address, phone, bloodGroup, dob, userRole, active, loginType, assignLocation, flatDiscount, dayEndDenomination, currentUser]);

  // Handle add employee
  const handleAddEmployee = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');
    
    // Validate inputs
    if (!nameRegex.test(name)) {
      setMessage('Employee name can only contain letters, spaces, hyphens, and apostrophes.');
      setMessageType('error');
      return;
    }
    if (!phoneRegex.test(phone) || phone.length !== 10) {
      setMessage('Phone number must be exactly 10 digits.');
      setMessageType('error');
      return;
    }
    if (password !== retypePassword) {
      setMessage("Passwords don't match!");
      setMessageType('error');
      return;
    }
    const adminPassword = prompt("Please enter your admin password to create employee account:");
    if (!adminPassword) {
      setMessage("Password confirmation required to create employee account.");
      setMessageType('error');
      return;
    }
    if (name && email && address && phone && userRole && password && currentUser) {
      try {
        const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
        if (!hasAccess) {
          setMessage('Access denied: You do not have permission to manage employees.');
          setMessageType('error');
          return;
        }
        setIsSyncing(true);
        try {
          await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
        } catch (error) {
          throw new Error('Invalid admin password. Please try again.');
        }
        const adminEmail = currentUser.email;
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        await signOut(auth);
        await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
        const adminEmailKey = adminEmail.replace(/\./g, '_');
        const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
        const employeeData = {
          active,
          name,
          email,
          address,
          phone,
          bloodGroup,
          dob,
          userRole,
          loginType,
          assignLocation,
          flatDiscount,
          dayEndDenomination,
          createdAt: new Date().toISOString(),
          createdBy: adminEmail,
          adminEmail: adminEmail,
          firebaseUid: userCredential.user.uid,
          syncStatus: 'pending',
          autoSyncEnabled: true
        };
        const newEmployeeRef = await push(employeesRef, employeeData);
        await copyAllDataToEmployee(adminEmail, email);
        const empUpdateRef = ref(database, `users/${adminEmailKey}/employees/${newEmployeeRef.key}`);
        await update(empUpdateRef, {
          syncStatus: 'synced',
          lastSyncAt: new Date().toISOString(),
          globalSyncActive: true
        });
        setTimeout(() => {
          globalSyncService.refreshSync();
        }, 1000);
        setTimeout(() => {
          globalSyncService.ensureSyncActive();
        }, 3000);
        setTimeout(() => {
          globalSyncService.initializeGlobalSync();
        }, 5000);
        handleResetForm();
        setShowEmployeeForm(false);
        setMessage(`Employee "${name}" added successfully! Real-time bidirectional sync is active.`);
        setMessageType('success');
      } catch (error) {
        console.error("❌ Error adding employee: ", error);
        setMessage(`Failed to add employee: ${error.message}`);
        setMessageType('error');
      } finally {
        setIsSyncing(false);
      }
    } else {
      setMessage("Please fill in all required fields!");
      setMessageType('error');
    }
  };

/* Replace the handleAddBranch function in ManageEmployeeRole.jsx with the following: */
const handleAddBranch = async (e) => {
  e.preventDefault();
  setMessage('');
  setMessageType('');
  
  // Validate inputs
  if (!nameRegex.test(branchName)) {
    setMessage('Branch name can only contain letters, spaces, hyphens, and apostrophes.');
    setMessageType('error');
    return;
  }
  if (!nameRegex.test(branchManager)) {
    setMessage('Manager name can only contain letters, spaces, hyphens, and apostrophes.');
    setMessageType('error');
    return;
  }
  if (branchPhone && (!phoneRegex.test(branchPhone) || branchPhone.length !== 10)) {
    setMessage('Phone number must be exactly 10 digits.');
    setMessageType('error');
    return;
  }
  if (branchUserPassword !== branchUserRetypePassword) {
    setMessage("Branch user passwords don't match!");
    setMessageType('error');
    return;
  }
  
  const adminPassword = prompt("Please enter your admin password to create branch account:");
  if (!adminPassword) {
    setMessage("Password confirmation required to create branch account.");
    setMessageType('error');
    return;
  }
  
  if (branchName && branchAddress && branchUserEmail && branchUserPassword && currentUser) {
    try {
      const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
      if (!hasAccess) {
        setMessage('Access denied: You do not have permission to manage branches.');
        setMessageType('error');
        return;
      }
      
      setIsSyncing(true);
      
      try {
        await signInWithEmailAndPassword(auth, currentUser.email, adminPassword);
      } catch (error) {
        throw new Error('Invalid admin password. Please try again.');
      }
      
      const adminEmail = currentUser.email;
      const userCredential = await createUserWithEmailAndPassword(auth, branchUserEmail, branchUserPassword);
      
      await signOut(auth);
      await signInWithEmailAndPassword(auth, adminEmail, adminPassword);
      
      const adminEmailKey = adminEmail.replace(/\./g, '_');
      const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
      
      const newBranchData = {
        name: branchName,
        address: branchAddress,
        phone: branchPhone,
        email: branchEmail,
        manager: branchManager,
        userEmail: branchUserEmail,
        firebaseUid: userCredential.user.uid,
        createdAt: new Date().toISOString(),
        createdBy: adminEmail,
        active: true,
        autoSyncEnabled: false
      };
      
      const newBranchRef = await push(branchesRef, newBranchData);
      
      const branchKey = branchUserEmail.replace(/\./g, '_');
      
      // Set branch profile
      const branchProfile = {
        role: 'branch',
        isBranch: true,
        adminEmail: adminEmail,
        adminEmailKey: adminEmailKey,
        canAccessAdminData: false, // Branch has no access to superadmin data
        branchInfo: {
          name: branchName,
          address: branchAddress,
          phone: branchPhone,
          email: branchEmail,
          manager: branchManager,
          userEmail: branchUserEmail
        },
        createdAt: new Date().toISOString(),
        lastSyncWith: adminEmailKey,
        plan: {
          type: 'branch_standard',
          createdAt: new Date().toISOString(),
          status: 'active',
          features: {
            inventoryManagement: true,
            salesTracking: true,
            reports: true,
            employeeManagement: false, // Branch cannot manage employees
            branchManagement: false // Branch cannot manage other branches
          },
          limits: {
            maxUsers: 10,
            maxStorage: '10GB',
            maxTransactions: 1000
          }
        }
      };
      await set(ref(database, `users/${branchKey}/profile`), branchProfile);
      
      // Set sync metadata for branch with empty data structure
      await set(ref(database, `users/${branchKey}/syncMetadata`), {
        isBranch: true,
        adminEmail: adminEmail,
        lastFullSyncAt: new Date().toISOString(),
        syncedPaths: [],
        syncStatus: 'active',
        autoSyncEnabled: false,
        excludedPaths: ['employees', 'branches', 'users'] // Explicitly exclude superadmin data
      });
      
      // Do not copy superadmin data to branch
      // Initialize empty data structures for the branch
      for (const path of SYNC_PATHS) {
        const pathRef = ref(database, `users/${branchKey}/${path}`);
        await set(pathRef, {}); // Initialize with empty object
        console.log(`✅ Initialized empty ${path} for branch`);
      }
      
      // Update the branch record in admin's branches list
      const branchUpdateRef = ref(database, `users/${adminEmailKey}/branches/${newBranchRef.key}`);
      await update(branchUpdateRef, {
        syncStatus: 'initialized',
        lastSyncAt: new Date().toISOString(),
        dataStructure: 'independent'
      });
      
      // Reset form
      setBranchName('');
      setBranchAddress('');
      setBranchPhone('');
      setBranchEmail('');
      setBranchManager('');
      setBranchUserEmail('');
      setBranchUserPassword('');
      setBranchUserRetypePassword('');
      setShowBranchForm(false);
      
      setMessage('Branch created successfully with independent data structure and standard account plan!');
      setMessageType('success');
      
    } catch (error) {
      console.error("❌ Error adding branch: ", error);
      setMessage(`Failed to add branch: ${error.message}`);
      setMessageType('error');
    } finally {
      setIsSyncing(false);
    }
  } else {
    setMessage("Please fill in all required fields including user credentials!");
    setMessageType('error');
  }
};

  // Load employees, branches, and roles
  useEffect(() => {
    if (currentUser) {
      console.log('📋 ManageEmployeeRole loaded - ensuring global sync is active...');
      setTimeout(() => {
        globalSyncService.ensureSyncActive();
      }, 500);
      const adminEmailKey = currentUser.email.replace(/\./g, '_');
      checkEmployeeAccess(currentUser.email, 'employees').then(hasAccess => {
        if (hasAccess) {
          const employeesRef = ref(database, `users/${adminEmailKey}/employees`);
          const unsubscribeEmployees = onValue(employeesRef, (snapshot) => {
            const data = snapshot.val();
            const employeesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
            setEmployees(employeesList);
          }, {
            errorCallback: (error) => {
              console.error('Error loading employees:', error);
              setMessage('Failed to load employees: ' + error.message);
              setMessageType('error');
            }
          });
          return () => unsubscribeEmployees();
        }
      });
      const branchesRef = ref(database, `users/${adminEmailKey}/branches`);
      const unsubscribeBranches = onValue(branchesRef, (snapshot) => {
        const data = snapshot.val();
        const branchesList = data ? Object.keys(data).map(key => ({ id: key, ...data[key] })) : [];
        setBranches(branchesList);
      }, {
        errorCallback: (error) => {
          console.error('Error loading branches:', error);
          setMessage('Failed to load branches: ' + error.message);
          setMessageType('error');
        }
      });
      const rolesRef = ref(database, `users/${adminEmailKey}/roles`);
      const unsubscribeRoles = onValue(rolesRef, (snapshot) => {
        const data = snapshot.val();
        const rolesList = data ? Object.values(data).map(role => role.roleName) : [];
        setRoles(rolesList);
      }, {
        errorCallback: (error) => {
          console.error('Error loading roles:', error);
          setMessage('Failed to load roles: ' + error.message);
          setMessageType('error');
        }
      });
      return () => {
        unsubscribeBranches();
        unsubscribeRoles();
      };
    }
  }, [currentUser, checkEmployeeAccess]);

  const handleResetForm = () => {
    setActive(true);
    setName('');
    setEmail('');
    setAddress('');
    setPhone('');
    setBloodGroup('');
    setDob('');
    setUserRole('');
    setLoginType('Main Login');
    setAssignLocation('');
    setFlatDiscount(false);
    setDayEndDenomination(false);
    setPassword('');
    setRetypePassword('');
  };

  const handleEmployeeClick = async (employee) => {
    const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
    if (hasAccess) {
      setSelectedEmployee(employee);
      setShowEmployeeDetails(true);
    } else {
      setMessage('Access denied: You do not have permission to view employee details.');
      setMessageType('error');
    }
  };

  const handleCancel = () => {
    handleResetForm();
    setShowEmployeeForm(false);
    setShowBranchForm(false);
    setMessage('');
    setMessageType('');
  };

  // Get max date for DOB (yesterday)
  const getMaxDate = () => {
    const today = new Date();
    today.setDate(today.getDate() - 1);
    return today.toISOString().split('T')[0];
  };

  // Styles
  const styles = {
    container: {
      maxWidth: '1200px',
      margin: '2rem auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
      minHeight: '100vh',
    },
    formWrapper: {
      backgroundColor: '#ffffff',
      borderRadius: '20px',
      padding: '2.5rem',
      border: '1px solid #e2e8f0',
    },
    heading: {
      fontSize: '2rem',
      fontWeight: '700',
      marginBottom: '2rem',
      color: '#1f2937',
      textAlign: 'center',
    },
    messageSuccess: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#d1fae5',
      color: '#065f46',
      border: '1px solid #a7f3d0',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    messageError: {
      padding: '1rem 1.5rem',
      marginBottom: '1.5rem',
      borderRadius: '12px',
      backgroundColor: '#fee2e2',
      color: '#b91c1c',
      border: '1px solid #fecaca',
      fontSize: '0.9rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    loadingContainer: {
      textAlign: 'center',
      padding: '4rem 2rem',
      color: '#6b7280',
    },
    loadingSpinner: {
      width: '3rem',
      height: '3rem',
      border: '4px solid #e5e7eb',
      borderTop: '4px solid #2563eb',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
      margin: '0 auto 1rem',
    },
    formLayout: {
      display: 'grid',
      gridTemplateColumns: '1fr',
      gap: '2rem',
    },
    twoColumnLayout: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '2rem',
    },
    section: {
      backgroundColor: '#fff',
      padding: '1.5rem',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
    },
    sectionHeading: {
      fontSize: '1.25rem',
      fontWeight: '600',
      marginBottom: '1rem',
      color: '#1f2937',
    },
    inputGroup: {
      marginBottom: '1rem',
      display: 'flex',
      flexDirection: 'column',
      gap: '0.5rem',
    },
    label: {
      display: 'block',
      fontSize: '0.875rem',
      fontWeight: '500',
      color: '#374151',
      marginBottom: '0.25rem',
    },
    requiredAsterisk: {
      color: '#ef4444',
      marginLeft: '0.25rem',
    },
    input: {
      display: 'block',
      width: '90%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      transition: 'border-color 0.2s ease',
    },
    select: {
      display: 'block',
      width: '100%',
      padding: '0.5rem 0.75rem',
      border: '1px solid #d1d5db',
      borderRadius: '6px',
      fontSize: '0.875rem',
      backgroundColor: '#fff',
      cursor: 'pointer',
      appearance: 'none',
      backgroundImage: `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'%3e%3cpath stroke='%236b7280' stroke-linecap='round' stroke-linejoin='round' stroke-width='1.5' d='m6 8 4 4 4-4'/%3e%3c/svg%3e")`,
      backgroundPosition: 'right 0.5rem center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '1em 1em',
      paddingRight: '2rem',
    },
    checkboxContainer: {
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    checkbox: {
      width: '1rem',
      height: '1rem',
      border: '1px solid #d1d5db',
      borderRadius: '4px',
      cursor: 'pointer',
    },
    buttonContainer: {
      marginTop: '2rem',
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '1rem',
      paddingTop: '1rem',
      borderTop: '1px solid #e2e8f0',
    },
    button: {
      padding: '0.5rem 1.5rem',
      borderRadius: '6px',
      fontWeight: '500',
      fontSize: '0.875rem',
      cursor: 'pointer',
      border: 'none',
      transition: 'all 0.2s ease',
    },
    submitButton: {
      backgroundColor: '#10b981',
      color: 'white',
    },
    cancelButton: {
      backgroundColor: '#ef4444',
      color: 'white',
    },
    gridTwoColumns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
      gap: '1rem',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '1.5rem',
      flexWrap: 'wrap',
      gap: '1rem',
    },
    headerTitle: {
      fontSize: '1.5rem',
      fontWeight: '700',
      color: '#2563eb',
    },
    headerButtons: {
      display: 'flex',
      gap: '0.5rem',
      flexWrap: 'wrap',
      alignItems: 'center',
    },
    addButton: {
      padding: '0.5rem 1.25rem',
      borderRadius: '6px',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '500',
      cursor: isSyncing ? 'not-allowed' : 'pointer',
      border: 'none',
      fontSize: '0.875rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(37, 99, 235, 0.3)',
    },
    branchButton: {
      padding: '0.5rem 1.25rem',
      borderRadius: '6px',
      backgroundColor: '#10b981',
      color: 'white',
      fontWeight: '500',
      cursor: isSyncing ? 'not-allowed' : 'pointer',
      border: 'none',
      fontSize: '0.875rem',
      transition: 'all 0.2s ease',
      boxShadow: '0 2px 8px rgba(16, 185, 129, 0.3)',
    },
    tableContainer: {
      marginTop: '1rem',
      overflowX: 'auto',
      backgroundColor: 'white',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
    },
    table: {
      width: '100%',
      borderCollapse: 'collapse',
      fontSize: '0.875rem',
    },
    tableHeader: {
      padding: '0.75rem',
      textAlign: 'center',
      backgroundColor: '#2563eb',
      color: 'white',
      fontWeight: '600',
      fontSize: '0.875rem',
      textTransform: 'uppercase',
      border: '1px solid #1e40af',
    },
    tableCell: {
      padding: '0.75rem',
      border: '1px solid #d1d5db',
      color: '#374151',
      textAlign: 'center',
      cursor: 'pointer',
    },
    branchCard: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      padding: '1rem',
      margin: '0.5rem 0',
    },
    branchName: {
      fontSize: '1rem',
      fontWeight: '600',
      color: '#1f2937',
      marginBottom: '0.5rem',
    },
    branchInfo: {
      fontSize: '0.875rem',
      color: '#6b7280',
      marginBottom: '0.25rem',
    },
    employeeDetailCard: {
      backgroundColor: '#f8fafc',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      padding: '1.5rem',
      margin: '1rem 0',
    },
    detailRow: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: '0.5rem 0',
      borderBottom: '1px solid #e2e8f0',
    },
    detailLabel: {
      fontWeight: '600',
      color: '#374151',
    },
    detailValue: {
      color: '#6b7280',
    },
    infoCard: {
      backgroundColor: '#dbeafe',
      border: '1px solid #93c5fd',
      borderRadius: '8px',
      padding: '1rem',
      margin: '1rem 0',
      color: '#1e40af',
    },
    syncStatusCard: {
      backgroundColor: isSyncing ? '#fef3c7' : '#dcfce7',
      border: `1px solid ${isSyncing ? '#fbbf24' : '#86efac'}`,
      borderRadius: '8px',
      padding: '1rem',
      margin: '1rem 0',
      color: isSyncing ? '#d97706' : '#15803d',
      display: 'flex',
      alignItems: 'center',
      gap: '0.5rem',
    },
    spinner: {
      width: '1rem',
      height: '1rem',
      border: '2px solid transparent',
      borderTop: '2px solid currentColor',
      borderRadius: '50%',
      animation: 'spin 1s linear infinite',
    },
  };

  if (!currentUser) {
    return (
      <div style={styles.container}>
        <div style={styles.formWrapper}>
          <div style={styles.loadingContainer}>
            <p>Please log in to access employee management.</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <style jsx>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        @media (max-width: 768px) {
          .twoColumnLayout {
            grid-template-columns: 1fr;
          }
          .gridTwoColumns {
            grid-template-columns: 1fr;
          }
          .buttonContainer {
            flex-direction: column;
          }
          .button {
            width: 100%;
            justify-content: center;
          }
        }
        input:focus,
        select:focus {
          outline: none;
          border-color: #2563eb;
          box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.1);
        }
        input:hover,
        select:hover {
          border-color: #a1a1aa;
        }
        button:hover:not(:disabled) {
          filter: brightness(90%);
        }
      `}</style>
      <div style={styles.formWrapper}>
        {showEmployeeForm ? (
          <>
            <h1 style={styles.heading}>👤 Add New Employee</h1>
            {message && (
              <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
                <span>{messageType === 'success' ? '✅' : '❌'}</span>
                {message}
              </div>
            )}
            {isSyncing ? (
              <div style={styles.loadingContainer}>
                <div style={styles.loadingSpinner}></div>
                <p>Creating employee and syncing data...</p>
              </div>
            ) : (
              <form onSubmit={handleAddEmployee}>
                <div style={styles.formLayout}>
                  <div style={styles.twoColumnLayout}>
                    <div style={styles.section}>
                      <h2 style={styles.sectionHeading}>📋 Personal Details</h2>
                      <div style={styles.inputGroup}>
                        <div style={styles.checkboxContainer}>
                          <input
                            type="checkbox"
                            checked={active}
                            onChange={(e) => setActive(e.target.checked)}
                            style={styles.checkbox}
                          />
                          <label style={styles.label}>Active</label>
                        </div>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Name<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="text"
                          value={name}
                          onChange={(e) => {
                            if (nameRegex.test(e.target.value) || e.target.value === '') {
                              setName(e.target.value);
                            }
                          }}
                          style={styles.input}
                          placeholder="Enter name"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Email<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          style={styles.input}
                          placeholder="Enter email"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Address<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="text"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                          style={styles.input}
                          placeholder="Enter address"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Phone No.<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="text"
                          value={phone}
                          onChange={(e) => {
                            if (phoneRegex.test(e.target.value) || e.target.value === '') {
                              setPhone(e.target.value);
                            }
                          }}
                          style={styles.input}
                          placeholder="Enter phone number"
                          required
                          maxLength={10}
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Blood Group</label>
                        <select
                          value={bloodGroup}
                          onChange={(e) => setBloodGroup(e.target.value)}
                          style={styles.select}
                        >
                          <option value="">Select Blood Group</option>
                          {BLOOD_GROUPS.map((group) => (
                            <option key={group} value={group}>
                              {group}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Date of Birth</label>
                        <input
                          type="date"
                          value={dob}
                          onChange={(e) => setDob(e.target.value)}
                          style={styles.input}
                          max={getMaxDate()}
                        />
                      </div>
                    </div>
                    <div style={styles.section}>
                      <h2 style={styles.sectionHeading}>🔑 Login Details</h2>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Role Name<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <select
                          value={userRole}
                          onChange={(e) => setUserRole(e.target.value)}
                          style={styles.select}
                          required
                        >
                          <option value="">Select Role</option>
                          {roles.map((role) => (
                            <option key={role} value={role}>
                              {role}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Login Type</label>
                        <select
                          value={loginType}
                          onChange={(e) => setLoginType(e.target.value)}
                          style={styles.select}
                        >
                          <option value="Main Login">Main Login</option>
                          <option value="Sub Login">Sub Login</option>
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Assign Location</label>
                        <select
                          value={assignLocation}
                          onChange={(e) => setAssignLocation(e.target.value)}
                          style={styles.select}
                        >
                          <option value="">Select Location</option>
                          {branches.map((branch) => (
                            <option key={branch.id} value={branch.name}>
                              {branch.name}
                            </option>
                          ))}
                          <option value="WAREHOUSE/Warehouse/Puduche">WAREHOUSE/Warehouse/Puduche</option>
                          <option value="STORE/Store/CITY">STORE/Store/CITY</option>
                        </select>
                      </div>
                      <div style={styles.inputGroup}>
                        <div style={styles.checkboxContainer}>
                          <input
                            type="checkbox"
                            checked={flatDiscount}
                            onChange={(e) => setFlatDiscount(e.target.checked)}
                            style={styles.checkbox}
                          />
                          <label style={styles.label}>Flat Discount</label>
                        </div>
                      </div>
                      <div style={styles.inputGroup}>
                        <div style={styles.checkboxContainer}>
                          <input
                            type="checkbox"
                            checked={dayEndDenomination}
                            onChange={(e) => setDayEndDenomination(e.target.checked)}
                            style={styles.checkbox}
                          />
                          <label style={styles.label}>Day End Denomination</label>
                        </div>
                      </div>
                    </div>
                    <div style={styles.section}>
                      <h2 style={styles.sectionHeading}>🔒 Credentials</h2>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Password<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          style={styles.input}
                          placeholder="Enter password"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Retype Password<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="password"
                          value={retypePassword}
                          onChange={(e) => setRetypePassword(e.target.value)}
                          style={styles.input}
                          placeholder="Retype password"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={styles.buttonContainer}>
                  <button
                    type="button"
                    onClick={handleCancel}
                    style={{ ...styles.button, ...styles.cancelButton }}
                    disabled={isSyncing}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{ ...styles.button, ...styles.submitButton }}
                    disabled={isSyncing}
                  >
                    Add Employee
                  </button>
                </div>
              </form>
            )}
          </>
        ) : showBranchForm ? (
          <>
            <h1 style={styles.heading}>🏢 Add New Branch</h1>
            {message && (
              <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
                <span>{messageType === 'success' ? '✅' : '❌'}</span>
                {message}
              </div>
            )}
            {isSyncing ? (
              <div style={styles.loadingContainer}>
                <div style={styles.loadingSpinner}></div>
                <p>Creating branch and syncing data...</p>
              </div>
            ) : (
              <form onSubmit={handleAddBranch}>
                <div style={styles.formLayout}>
                  <div style={styles.twoColumnLayout}>
                    <div style={styles.section}>
                      <h2 style={styles.sectionHeading}>🏢 Branch Details</h2>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Branch Name<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="text"
                          value={branchName}
                          onChange={(e) => {
                            if (nameRegex.test(e.target.value) || e.target.value === '') {
                              setBranchName(e.target.value);
                            }
                          }}
                          style={styles.input}
                          placeholder="Enter branch name"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Address<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="text"
                          value={branchAddress}
                          onChange={(e) => setBranchAddress(e.target.value)}
                          style={styles.input}
                          placeholder="Enter address"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Phone</label>
                        <input
                          type="text"
                          value={branchPhone}
                          onChange={(e) => {
                            if (phoneRegex.test(e.target.value) || e.target.value === '') {
                              setBranchPhone(e.target.value);
                            }
                          }}
                          style={styles.input}
                          placeholder="Enter phone number"
                          maxLength={10}
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Email</label>
                        <input
                          type="email"
                          value={branchEmail}
                          onChange={(e) => setBranchEmail(e.target.value)}
                          style={styles.input}
                          placeholder="Enter email"
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>Manager</label>
                        <input
                          type="text"
                          value={branchManager}
                          onChange={(e) => {
                            if (nameRegex.test(e.target.value) || e.target.value === '') {
                              setBranchManager(e.target.value);
                            }
                          }}
                          style={styles.input}
                          placeholder="Enter manager name"
                        />
                      </div>
                    </div>
                    <div style={styles.section}>
                      <h2 style={styles.sectionHeading}>🔒 Branch User Credentials</h2>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          User Email<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="email"
                          value={branchUserEmail}
                          onChange={(e) => setBranchUserEmail(e.target.value)}
                          style={styles.input}
                          placeholder="Enter user email for branch login"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          User Password<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="password"
                          value={branchUserPassword}
                          onChange={(e) => setBranchUserPassword(e.target.value)}
                          style={styles.input}
                          placeholder="Enter user password"
                          required
                        />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>
                          Retype User Password<span style={styles.requiredAsterisk}>*</span>
                        </label>
                        <input
                          type="password"
                          value={branchUserRetypePassword}
                          onChange={(e) => setBranchUserRetypePassword(e.target.value)}
                          style={styles.input}
                          placeholder="Retype user password"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div style={styles.buttonContainer}>
                  <button
                    type="button"
                    onClick={handleCancel}
                    style={{ ...styles.button, ...styles.cancelButton }}
                    disabled={isSyncing}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    style={{ ...styles.button, ...styles.submitButton }}
                    disabled={isSyncing}
                  >
                    Add Branch
                  </button>
                </div>
              </form>
            )}
          </>
        ) : showEmployeeDetails && selectedEmployee ? (
          <>
            <h1 style={styles.heading}>👤 Employee Details - {selectedEmployee.name}</h1>
            {message && (
              <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
                <span>{messageType === 'success' ? '✅' : '❌'}</span>
                {message}
              </div>
            )}
            <div style={styles.formLayout}>
              <div style={styles.twoColumnLayout}>
                <div style={styles.section}>
                  <h2 style={styles.sectionHeading}>👤 Personal Information</h2>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Name</label>
                    <input
                      type="text"
                      value={selectedEmployee.name}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Email</label>
                    <input
                      type="email"
                      value={selectedEmployee.email}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Phone</label>
                    <input
                      type="text"
                      value={selectedEmployee.phone}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Address</label>
                    <input
                      type="text"
                      value={selectedEmployee.address}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Blood Group</label>
                    <input
                      type="text"
                      value={selectedEmployee.bloodGroup || 'Not specified'}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Date of Birth</label>
                    <input
                      type="text"
                      value={selectedEmployee.dob || 'Not specified'}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                </div>
                <div style={styles.section}>
                  <h2 style={styles.sectionHeading}>💼 Work Information</h2>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Role</label>
                    <input
                      type="text"
                      value={selectedEmployee.userRole}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Login Type</label>
                    <input
                      type="text"
                      value={selectedEmployee.loginType}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Assigned Location</label>
                    <input
                      type="text"
                      value={selectedEmployee.assignLocation || 'Not assigned'}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Status</label>
                    <input
                      type="text"
                      value={selectedEmployee.active ? 'Active' : 'Inactive'}
                      style={{ ...styles.input, color: selectedEmployee.active ? '#10b981' : '#ef4444' }}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Admin Email</label>
                    <input
                      type="text"
                      value={selectedEmployee.adminEmail}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Sync Status</label>
                    <input
                      type="text"
                      value={
                        selectedEmployee.syncStatus === 'synced'
                          ? 'Real-time Sync Active'
                          : selectedEmployee.syncStatus === 'pending'
                          ? 'Sync Pending'
                          : 'Bidirectional Sync'
                      }
                      style={{
                        ...styles.input,
                        color:
                          selectedEmployee.syncStatus === 'synced'
                            ? '#10b981'
                            : selectedEmployee.syncStatus === 'pending'
                            ? '#f59e0b'
                            : '#2563eb'
                      }}
                      readOnly
                    />
                  </div>
                </div>
                <div style={styles.section}>
                  <h2 style={styles.sectionHeading}>⚙️ Permissions & Settings</h2>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Flat Discount</label>
                    <input
                      type="text"
                      value={selectedEmployee.flatDiscount ? 'Enabled' : 'Disabled'}
                      style={{ ...styles.input, color: selectedEmployee.flatDiscount ? '#10b981' : '#ef4444' }}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Day End Denomination</label>
                    <input
                      type="text"
                      value={selectedEmployee.dayEndDenomination ? 'Enabled' : 'Disabled'}
                      style={{ ...styles.input, color: selectedEmployee.dayEndDenomination ? '#10b981' : '#ef4444' }}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Data Access Level</label>
                    <input
                      type="text"
                      value="Full Business Data (Excluding Employee & Branch Management)"
                      style={{ ...styles.input, color: '#10b981' }}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Created Date</label>
                    <input
                      type="text"
                      value={
                        selectedEmployee.createdAt
                          ? new Date(selectedEmployee.createdAt).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })
                          : 'Not available'
                      }
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Firebase UID</label>
                    <input
                      type="text"
                      value={selectedEmployee.firebaseUid ? selectedEmployee.firebaseUid.substring(0, 8) + '...' : 'Not available'}
                      style={styles.input}
                      readOnly
                    />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>Sync Type</label>
                    <input
                      type="text"
                      value="Bidirectional Real-time (Business Data Only)"
                      style={{ ...styles.input, color: '#8b5cf6' }}
                      readOnly
                    />
                  </div>
                </div>
              </div>
              <div style={styles.section}>
                <h2 style={styles.sectionHeading}>📊 Real-time Data Access & Sync Status</h2>
                <div style={{ marginBottom: '1rem', fontSize: '0.875rem', color: '#6b7280' }}>
                  All business data changes are automatically synchronized in real-time between admin and employee accounts (excluding employee and branch management data).
                </div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem' }}>
                  {SYNC_PATHS.map((path, index) => (
                    <div
                      key={path}
                      style={{
                        backgroundColor: ['#dbeafe', '#dcfce7', '#fef3c7', '#fce7f3', '#f3e8ff', '#ecfdf5', '#fef2f2', '#f0fdfa'][index % 8],
                        padding: '1rem',
                        borderRadius: '8px',
                        textAlign: 'center'
                      }}
                    >
                      <div style={{ fontSize: '1.5rem', fontWeight: '700', color: ['#2563eb', '#16a34a', '#d97706', '#be185d', '#7c3aed', '#059669', '#dc2626', '#0d9488'][index % 8] }}>🔄</div>
                      <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '600' }}>{path.charAt(0).toUpperCase() + path.slice(1)}</div>
                      <div style={{ fontSize: '0.75rem', color: '#10b981', marginTop: '0.25rem' }}>Real-time Sync</div>
                    </div>
                  ))}
                </div>
                <div style={{ marginTop: '1.5rem', padding: '1rem', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #e2e8f0' }}>
                  <h4 style={{ margin: '0 0 0.75rem 0', fontSize: '0.9rem', fontWeight: '600', color: '#374151' }}>
                    🔄 Bidirectional Sync Flow
                  </h4>
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', flexWrap: 'wrap' }}>
                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#2563eb', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
                      {selectedEmployee.adminEmail}
                    </div>
                    <div style={{ fontSize: '1.2rem' }}>↔️</div>
                    <div style={{ padding: '0.5rem 1rem', backgroundColor: '#10b981', color: 'white', borderRadius: '6px', fontSize: '0.875rem', fontWeight: '600' }}>
                      {selectedEmployee.email}
                    </div>
                  </div>
                  <div style={{ textAlign: 'center', fontSize: '0.75rem', color: '#6b7280', marginTop: '0.5rem' }}>
                    Real-time bidirectional data synchronization active (business data only)
                  </div>
                </div>
              </div>
            </div>
            <div style={styles.buttonContainer}>
              <button
                style={{ ...styles.button, backgroundColor: '#2563eb', color: 'white' }}
                onClick={async () => {
                  const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
                  if (hasAccess) {
                    setMessage('Edit functionality will be implemented');
                    setMessageType('info');
                    setShowEmployeeDetails(false);
                  } else {
                    setMessage('Access denied: You do not have permission to edit employees.');
                    setMessageType('error');
                  }
                }}
              >
                ✏️ Edit Employee
              </button>
              <button
                style={{ ...styles.button, backgroundColor: selectedEmployee.active ? '#ef4444' : '#10b981', color: 'white' }}
                onClick={async () => {
                  const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
                  if (!hasAccess) {
                    setMessage('Access denied: You do not have permission to modify employee status.');
                    setMessageType('error');
                    return;
                  }
                  const action = selectedEmployee.active ? 'deactivate' : 'activate';
                  if (window.confirm(`Are you sure you want to ${action} this employee? This will affect their data sync status.`)) {
                    setMessage(`${action.charAt(0).toUpperCase() + action.slice(1)} functionality will be implemented`);
                    setMessageType('info');
                  }
                }}
              >
                {selectedEmployee.active ? '🚫 Deactivate' : '✅ Activate'}
              </button>
              <button
                style={{ ...styles.button, backgroundColor: '#f59e0b', color: 'white' }}
                onClick={async () => {
                  const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
                  if (!hasAccess) {
                    setMessage('Access denied: You do not have permission to reset employee passwords.');
                    setMessageType('error');
                    return;
                  }
                  if (window.confirm('Reset password for this employee? They will need to use the new password to login. Data sync will remain active.')) {
                    setMessage('Reset password functionality will be implemented');
                    setMessageType('info');
                  }
                }}
              >
                🔑 Reset Password
              </button>
              <button
                style={{ ...styles.button, backgroundColor: '#6b7280', color: 'white' }}
                onClick={() => setShowEmployeeDetails(false)}
              >
                ❌ Close
              </button>
            </div>
          </>
        ) : (
          <>
            <div style={styles.header}>
              <div style={styles.headerTitle}>
                Manage Employee Role & Branches
                <div style={{ fontSize: '0.875rem', color: '#6b7280', fontWeight: '400' }}>
                  Logged in as: {currentUser.email}
                </div>
              </div>
              <div style={styles.headerButtons}>
                <button
                  style={styles.addButton}
                  onClick={async () => {
                    const hasAccess = await checkEmployeeAccess(currentUser.email, 'employees');
                    if (hasAccess && !isSyncing) setShowEmployeeForm(true);
                    else if (!hasAccess) {
                      setMessage('Access denied: You do not have permission to add employees.');
                      setMessageType('error');
                    }
                  }}
                  disabled={isSyncing}
                >
                  + Add Employee
                </button>
                <button
                  style={styles.branchButton}
                  onClick={async () => {
                    const hasAccess = await checkEmployeeAccess(currentUser.email, 'branches');
                    if (hasAccess && !isSyncing) setShowBranchForm(true);
                    else if (!hasAccess) {
                      setMessage('Access denied: You do not have permission to add branches.');
                      setMessageType('error');
                    }
                  }}
                  disabled={isSyncing}
                >
                  + Add Branch
                </button>
              </div>
            </div>
            {message && (
              <div style={messageType === 'success' ? styles.messageSuccess : styles.messageError}>
                <span>{messageType === 'success' ? '✅' : '❌'}</span>
                {message}
              </div>
            )}
            <div style={styles.section}>
              <h2 style={styles.sectionHeading}>🏢 Branches ({branches.length})</h2>
              {branches.length === 0 ? (
                <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                  No branches added yet. Click "Add Branch" to create your first branch.
                </p>
              ) : (
                <div style={styles.gridTwoColumns}>
                  {branches.map((branch) => (
                    <div key={branch.id} style={styles.branchCard}>
                      <div style={styles.branchName}>{branch.name}</div>
                      <div style={styles.branchInfo}>📍 {branch.address}</div>
                      {branch.phone && <div style={styles.branchInfo}>📞 {branch.phone}</div>}
                      {branch.email && <div style={styles.branchInfo}>📧 {branch.email}</div>}
                      {branch.manager && <div style={styles.branchInfo}>👤 Manager: {branch.manager}</div>}
                      <div style={{ fontSize: '0.75rem', color: '#10b981', fontWeight: '600', marginTop: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.25rem' }}>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div style={styles.section}>
              <h2 style={styles.sectionHeading}>📋 Employee List ({employees.length})</h2>
              {employees.length === 0 ? (
                <p style={{ color: '#6b7280', textAlign: 'center', padding: '2rem' }}>
                  No employees added yet. Click "Add Employee" to add your first employee.
                </p>
              ) : (
                <div style={styles.tableContainer}>
                  <table style={styles.table}>
                    <thead>
                      <tr>
                        <th style={styles.tableHeader}>ID</th>
                        <th style={styles.tableHeader}>USER NAME</th>
                        <th style={styles.tableHeader}>ROLE</th>
                        <th style={styles.tableHeader}>EMAIL</th>
                        <th style={styles.tableHeader}>ADMIN EMAIL</th>
                        <th style={styles.tableHeader}>ASSIGNED LOCATION</th>
                        <th style={styles.tableHeader}>SYNC STATUS</th>
                        <th style={styles.tableHeader}>STATUS</th>
                        <th style={styles.tableHeader}>ACTION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employees.map((employee, index) => (
                        <tr
                          key={employee.id}
                          style={{ backgroundColor: index % 2 === 0 ? '#f7fafc' : 'white' }}
                          onClick={() => handleEmployeeClick(employee)}
                        >
                          <td style={styles.tableCell}>{index + 1}</td>
                          <td style={styles.tableCell}>{employee.name}</td>
                          <td style={styles.tableCell}>{employee.userRole}</td>
                          <td style={styles.tableCell}>{employee.email}</td>
                          <td style={styles.tableCell}>{employee.adminEmail}</td>
                          <td style={styles.tableCell}>{employee.assignLocation || 'Not assigned'}</td>
                          <td style={styles.tableCell}>
                            <span style={{
                              color: employee.syncStatus === 'synced' ? '#10b981' : employee.syncStatus === 'pending' ? '#f59e0b' : '#6b7280',
                              fontWeight: '600'
                            }}>
                              {employee.syncStatus === 'synced' ? '✅ Synced' : employee.syncStatus === 'pending' ? '⏳ Pending' : '🔄 Active'}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{ color: employee.active ? '#10b981' : '#ef4444', fontWeight: '600' }}>
                              {employee.active ? 'Active' : 'Inactive'}
                            </span>
                          </td>
                          <td style={styles.tableCell}>
                            <span style={{ color: '#f44336', cursor: 'pointer' }}>✏️</span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ManageEmployeeRole;